/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const updateDocumentEmbeddingStatus = /* GraphQL */ `
  mutation UpdateDocumentEmbeddingStatus(
    $id: String!
    $embedding_status: String!
    $completion_percentage: Float
  ) {
    updateDocumentEmbeddingStatus(
      id: $id
      embedding_status: $embedding_status
      completion_percentage: $completion_percentage
    ) {
      id
      embedding_status
      completion_percentage
    }
  }
`;
export const updatePlannerStatus = /* GraphQL */ `
  mutation UpdatePlannerStatus(
    $id: ID!
    $isAIReplying: Boolean
    $activeMessageForAI: ID
  ) {
    updatePlannerStatus(
      id: $id
      isAIReplying: $isAIReplying
      activeMessageForAI: $activeMessageForAI
    ) {
      id
      isAIReplying
      activeMessageForAI
    }
  }
`;
export const createAppConfig = /* GraphQL */ `
  mutation CreateAppConfig(
    $input: CreateAppConfigInput!
    $condition: ModelAppConfigConditionInput
  ) {
    createAppConfig(input: $input, condition: $condition) {
      id
      saveTimer
      screenResponsiveWidth
      mobileResponsiveWidth
      veryLargeScreenResponsiveWidth
      chartMaxHeight
      inactiveTimeout
      sideMenuWidth
      availableLanguages
      baseIntents
      baseEntities
      baseTopics
      supportDomain
      metadata
      announcement
      lastAnnouncementInt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateAppConfig = /* GraphQL */ `
  mutation UpdateAppConfig(
    $input: UpdateAppConfigInput!
    $condition: ModelAppConfigConditionInput
  ) {
    updateAppConfig(input: $input, condition: $condition) {
      id
      saveTimer
      screenResponsiveWidth
      mobileResponsiveWidth
      veryLargeScreenResponsiveWidth
      chartMaxHeight
      inactiveTimeout
      sideMenuWidth
      availableLanguages
      baseIntents
      baseEntities
      baseTopics
      supportDomain
      metadata
      announcement
      lastAnnouncementInt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteAppConfig = /* GraphQL */ `
  mutation DeleteAppConfig(
    $input: DeleteAppConfigInput!
    $condition: ModelAppConfigConditionInput
  ) {
    deleteAppConfig(input: $input, condition: $condition) {
      id
      saveTimer
      screenResponsiveWidth
      mobileResponsiveWidth
      veryLargeScreenResponsiveWidth
      chartMaxHeight
      inactiveTimeout
      sideMenuWidth
      availableLanguages
      baseIntents
      baseEntities
      baseTopics
      supportDomain
      metadata
      announcement
      lastAnnouncementInt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      owner
      username
      user_email
      user_email_verified
      user_phone_number
      timezone
      language
      isSentenceSplitEnabled
      isImplicitSelfEnabled
      replyLanguage
      theme
      user_phone_number_verified
      userInstructions
      userMemories
      isOnboarded
      userHelperPreferences
      type
      sourceCode
      referralCode
      referredBy
      couponCode
      image
      workspaces {
        items {
          id
          owner
          title
          visibility
          userID
          isMed
          type
          usagePlanID
          workspaceTokenID
          workspaceToken
          subscriptionType
          subscriptionId
          subscriptionStatus
          enableExperimentalFeatures
          utilityEndpoint
          utilityUrl
          utilityUrlStatus
          utilityUrlType
          utilityBaseModel
          utilityProvider
          codingEndpoint
          codingUrl
          codingUrlStatus
          codingUrlType
          codingBaseModel
          codingProvider
          generalPurposeEndpoint
          generalPurposeUrl
          generalPurposeUrlStatus
          generalPurposeUrlType
          generalPurposeBaseModel
          generalPurposeProvider
          qaEnpoint
          qaUrl
          qaUrlStatus
          qaUrlType
          qaBaseModel
          qaProvider
          cnEndpoint
          cnUrl
          cnUrlStatus
          cnUrlType
          cnBaseModel
          cnProvider
          gnEnpoint
          gnUrl
          gnUrlStatus
          gnUrlType
          gnBaseModel
          gnProvider
          nlpEnpoint
          nlpUrl
          nlpUrlStatus
          nlpUrlType
          nlpBaseModel
          nlpProvider
          embeddingEndpoint
          embeddingUrl
          embeddingUrlStatus
          embeddingUrlType
          embeddingBaseModel
          embeddingProvider
          chartingEndpoint
          chartingUrl
          chartingUrlStatus
          chartingUrlType
          chartingBaseModel
          chartingProvider
          imagingEndpoint
          imagingUrl
          imagingUrlStatus
          imagingUrlType
          imagingBaseModel
          imagingProvider
          reasoningEndpoint
          reasoningUrl
          reasoningUrlStatus
          reasoningUrlType
          reasoningBaseModel
          reasoningProvider
          defaultChatVisibility
          billingStatus
          lastBillingDate
          lastConsumptionNotificationDate
          activeUntil
          paymentFailed
          bulkImportAllowed
          lastPaymentAttempt
          targetSubscriptionType
          lastChangeSubscriptionDate
          maxUsers
          minUsers
          contractStartDate
          xeroId
          xeroContactId
          xeroInvoiceId
          lastXeroBillingDate
          billingProvider
          supportHours
          supportHoursUsed
          reservedComputeAllocation
          baseModel
          domain
          customImageRecognitionModel
          customVectorDB
          customUoiPrice
          disabled
          users
          userCognitoIds
          workspaceCreationDate
          workspaceModelReady
          enableDeleteFunctionInAgents
          enableUpdateFunctionInAgents
          enableCustomFunctionInAgents
          defaultChatAgent
          defaultBusinessAnalystAgent
          defaultContentCreatorAgent
          isSentimentReviewerEnabled
          isExtendedContentCreatorEnabled
          isExtendedBusinessAnalystReportEnabled
          customIndexedDBendpoint
          createdBy
          updatedBy
          federationMetadataUrl
          federationMetadataUrlStatus
          federationMetadataUrlType
          ssoType
          ssoDomain
          ssoProviderName
          isMultiLanguageEnabled
          customChartingConfig
          twilioConfig
          emailConfig
          isMFAEnabled
          advancedVectorisation
          advancedCompute
          enableAutoInvite
          autoInviteDomain
          autoInviteUserRole
          customMaxPowerUsers
          customUoiBudget
          requestsPer30MinutesFactor
          webhookUrl
          webhookAuthorisationType
          webhookAuthorisationID
          logo
          enforceRegionalModels
          blockedModels
          billingPeriodStart
          billingPeriodEnd
          parentWorkspaceID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      cognitoUsername
      stripeCustomerId
      subscribedToNewsletter
      newsletterConsentedAt
      newsletterConsentMethod
      newsletterConsentTermsVersion
      newsletterPromptShown
      newsletterSubscriptionStatus
      newsletterUpdatedAt
      isLead
      stripePaymentIntentId
      maximumNumberOfWorkspaces
      workspacesAccessLevel {
        items {
          id
          workspaceID
          userID
          userType
          policyID
          favoriteAgents
          recentLocalFolders
          recentFiles
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      lastViewedReleaseVersion
      isMFAEnabled
      desktopAppInstalled
      lastAnnouncementViewedInt
      expoPushTokens
      enableExperimentalFeatures
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      owner
      username
      user_email
      user_email_verified
      user_phone_number
      timezone
      language
      isSentenceSplitEnabled
      isImplicitSelfEnabled
      replyLanguage
      theme
      user_phone_number_verified
      userInstructions
      userMemories
      isOnboarded
      userHelperPreferences
      type
      sourceCode
      referralCode
      referredBy
      couponCode
      image
      workspaces {
        items {
          id
          owner
          title
          visibility
          userID
          isMed
          type
          usagePlanID
          workspaceTokenID
          workspaceToken
          subscriptionType
          subscriptionId
          subscriptionStatus
          enableExperimentalFeatures
          utilityEndpoint
          utilityUrl
          utilityUrlStatus
          utilityUrlType
          utilityBaseModel
          utilityProvider
          codingEndpoint
          codingUrl
          codingUrlStatus
          codingUrlType
          codingBaseModel
          codingProvider
          generalPurposeEndpoint
          generalPurposeUrl
          generalPurposeUrlStatus
          generalPurposeUrlType
          generalPurposeBaseModel
          generalPurposeProvider
          qaEnpoint
          qaUrl
          qaUrlStatus
          qaUrlType
          qaBaseModel
          qaProvider
          cnEndpoint
          cnUrl
          cnUrlStatus
          cnUrlType
          cnBaseModel
          cnProvider
          gnEnpoint
          gnUrl
          gnUrlStatus
          gnUrlType
          gnBaseModel
          gnProvider
          nlpEnpoint
          nlpUrl
          nlpUrlStatus
          nlpUrlType
          nlpBaseModel
          nlpProvider
          embeddingEndpoint
          embeddingUrl
          embeddingUrlStatus
          embeddingUrlType
          embeddingBaseModel
          embeddingProvider
          chartingEndpoint
          chartingUrl
          chartingUrlStatus
          chartingUrlType
          chartingBaseModel
          chartingProvider
          imagingEndpoint
          imagingUrl
          imagingUrlStatus
          imagingUrlType
          imagingBaseModel
          imagingProvider
          reasoningEndpoint
          reasoningUrl
          reasoningUrlStatus
          reasoningUrlType
          reasoningBaseModel
          reasoningProvider
          defaultChatVisibility
          billingStatus
          lastBillingDate
          lastConsumptionNotificationDate
          activeUntil
          paymentFailed
          bulkImportAllowed
          lastPaymentAttempt
          targetSubscriptionType
          lastChangeSubscriptionDate
          maxUsers
          minUsers
          contractStartDate
          xeroId
          xeroContactId
          xeroInvoiceId
          lastXeroBillingDate
          billingProvider
          supportHours
          supportHoursUsed
          reservedComputeAllocation
          baseModel
          domain
          customImageRecognitionModel
          customVectorDB
          customUoiPrice
          disabled
          users
          userCognitoIds
          workspaceCreationDate
          workspaceModelReady
          enableDeleteFunctionInAgents
          enableUpdateFunctionInAgents
          enableCustomFunctionInAgents
          defaultChatAgent
          defaultBusinessAnalystAgent
          defaultContentCreatorAgent
          isSentimentReviewerEnabled
          isExtendedContentCreatorEnabled
          isExtendedBusinessAnalystReportEnabled
          customIndexedDBendpoint
          createdBy
          updatedBy
          federationMetadataUrl
          federationMetadataUrlStatus
          federationMetadataUrlType
          ssoType
          ssoDomain
          ssoProviderName
          isMultiLanguageEnabled
          customChartingConfig
          twilioConfig
          emailConfig
          isMFAEnabled
          advancedVectorisation
          advancedCompute
          enableAutoInvite
          autoInviteDomain
          autoInviteUserRole
          customMaxPowerUsers
          customUoiBudget
          requestsPer30MinutesFactor
          webhookUrl
          webhookAuthorisationType
          webhookAuthorisationID
          logo
          enforceRegionalModels
          blockedModels
          billingPeriodStart
          billingPeriodEnd
          parentWorkspaceID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      cognitoUsername
      stripeCustomerId
      subscribedToNewsletter
      newsletterConsentedAt
      newsletterConsentMethod
      newsletterConsentTermsVersion
      newsletterPromptShown
      newsletterSubscriptionStatus
      newsletterUpdatedAt
      isLead
      stripePaymentIntentId
      maximumNumberOfWorkspaces
      workspacesAccessLevel {
        items {
          id
          workspaceID
          userID
          userType
          policyID
          favoriteAgents
          recentLocalFolders
          recentFiles
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      lastViewedReleaseVersion
      isMFAEnabled
      desktopAppInstalled
      lastAnnouncementViewedInt
      expoPushTokens
      enableExperimentalFeatures
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      owner
      username
      user_email
      user_email_verified
      user_phone_number
      timezone
      language
      isSentenceSplitEnabled
      isImplicitSelfEnabled
      replyLanguage
      theme
      user_phone_number_verified
      userInstructions
      userMemories
      isOnboarded
      userHelperPreferences
      type
      sourceCode
      referralCode
      referredBy
      couponCode
      image
      workspaces {
        items {
          id
          owner
          title
          visibility
          userID
          isMed
          type
          usagePlanID
          workspaceTokenID
          workspaceToken
          subscriptionType
          subscriptionId
          subscriptionStatus
          enableExperimentalFeatures
          utilityEndpoint
          utilityUrl
          utilityUrlStatus
          utilityUrlType
          utilityBaseModel
          utilityProvider
          codingEndpoint
          codingUrl
          codingUrlStatus
          codingUrlType
          codingBaseModel
          codingProvider
          generalPurposeEndpoint
          generalPurposeUrl
          generalPurposeUrlStatus
          generalPurposeUrlType
          generalPurposeBaseModel
          generalPurposeProvider
          qaEnpoint
          qaUrl
          qaUrlStatus
          qaUrlType
          qaBaseModel
          qaProvider
          cnEndpoint
          cnUrl
          cnUrlStatus
          cnUrlType
          cnBaseModel
          cnProvider
          gnEnpoint
          gnUrl
          gnUrlStatus
          gnUrlType
          gnBaseModel
          gnProvider
          nlpEnpoint
          nlpUrl
          nlpUrlStatus
          nlpUrlType
          nlpBaseModel
          nlpProvider
          embeddingEndpoint
          embeddingUrl
          embeddingUrlStatus
          embeddingUrlType
          embeddingBaseModel
          embeddingProvider
          chartingEndpoint
          chartingUrl
          chartingUrlStatus
          chartingUrlType
          chartingBaseModel
          chartingProvider
          imagingEndpoint
          imagingUrl
          imagingUrlStatus
          imagingUrlType
          imagingBaseModel
          imagingProvider
          reasoningEndpoint
          reasoningUrl
          reasoningUrlStatus
          reasoningUrlType
          reasoningBaseModel
          reasoningProvider
          defaultChatVisibility
          billingStatus
          lastBillingDate
          lastConsumptionNotificationDate
          activeUntil
          paymentFailed
          bulkImportAllowed
          lastPaymentAttempt
          targetSubscriptionType
          lastChangeSubscriptionDate
          maxUsers
          minUsers
          contractStartDate
          xeroId
          xeroContactId
          xeroInvoiceId
          lastXeroBillingDate
          billingProvider
          supportHours
          supportHoursUsed
          reservedComputeAllocation
          baseModel
          domain
          customImageRecognitionModel
          customVectorDB
          customUoiPrice
          disabled
          users
          userCognitoIds
          workspaceCreationDate
          workspaceModelReady
          enableDeleteFunctionInAgents
          enableUpdateFunctionInAgents
          enableCustomFunctionInAgents
          defaultChatAgent
          defaultBusinessAnalystAgent
          defaultContentCreatorAgent
          isSentimentReviewerEnabled
          isExtendedContentCreatorEnabled
          isExtendedBusinessAnalystReportEnabled
          customIndexedDBendpoint
          createdBy
          updatedBy
          federationMetadataUrl
          federationMetadataUrlStatus
          federationMetadataUrlType
          ssoType
          ssoDomain
          ssoProviderName
          isMultiLanguageEnabled
          customChartingConfig
          twilioConfig
          emailConfig
          isMFAEnabled
          advancedVectorisation
          advancedCompute
          enableAutoInvite
          autoInviteDomain
          autoInviteUserRole
          customMaxPowerUsers
          customUoiBudget
          requestsPer30MinutesFactor
          webhookUrl
          webhookAuthorisationType
          webhookAuthorisationID
          logo
          enforceRegionalModels
          blockedModels
          billingPeriodStart
          billingPeriodEnd
          parentWorkspaceID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      cognitoUsername
      stripeCustomerId
      subscribedToNewsletter
      newsletterConsentedAt
      newsletterConsentMethod
      newsletterConsentTermsVersion
      newsletterPromptShown
      newsletterSubscriptionStatus
      newsletterUpdatedAt
      isLead
      stripePaymentIntentId
      maximumNumberOfWorkspaces
      workspacesAccessLevel {
        items {
          id
          workspaceID
          userID
          userType
          policyID
          favoriteAgents
          recentLocalFolders
          recentFiles
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      lastViewedReleaseVersion
      isMFAEnabled
      desktopAppInstalled
      lastAnnouncementViewedInt
      expoPushTokens
      enableExperimentalFeatures
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createWorkspace = /* GraphQL */ `
  mutation CreateWorkspace(
    $input: CreateWorkspaceInput!
    $condition: ModelWorkspaceConditionInput
  ) {
    createWorkspace(input: $input, condition: $condition) {
      id
      owner
      title
      visibility
      userID
      isMed
      type
      usagePlanID
      workspaceTokenID
      workspaceToken
      subscriptionType
      subscriptionId
      subscriptionStatus
      enableExperimentalFeatures
      utilityEndpoint
      utilityUrl
      utilityUrlStatus
      utilityUrlType
      utilityBaseModel
      utilityProvider
      codingEndpoint
      codingUrl
      codingUrlStatus
      codingUrlType
      codingBaseModel
      codingProvider
      generalPurposeEndpoint
      generalPurposeUrl
      generalPurposeUrlStatus
      generalPurposeUrlType
      generalPurposeBaseModel
      generalPurposeProvider
      qaEnpoint
      qaUrl
      qaUrlStatus
      qaUrlType
      qaBaseModel
      qaProvider
      cnEndpoint
      cnUrl
      cnUrlStatus
      cnUrlType
      cnBaseModel
      cnProvider
      gnEnpoint
      gnUrl
      gnUrlStatus
      gnUrlType
      gnBaseModel
      gnProvider
      nlpEnpoint
      nlpUrl
      nlpUrlStatus
      nlpUrlType
      nlpBaseModel
      nlpProvider
      embeddingEndpoint
      embeddingUrl
      embeddingUrlStatus
      embeddingUrlType
      embeddingBaseModel
      embeddingProvider
      chartingEndpoint
      chartingUrl
      chartingUrlStatus
      chartingUrlType
      chartingBaseModel
      chartingProvider
      imagingEndpoint
      imagingUrl
      imagingUrlStatus
      imagingUrlType
      imagingBaseModel
      imagingProvider
      reasoningEndpoint
      reasoningUrl
      reasoningUrlStatus
      reasoningUrlType
      reasoningBaseModel
      reasoningProvider
      defaultChatVisibility
      billingStatus
      lastBillingDate
      lastConsumptionNotificationDate
      activeUntil
      paymentFailed
      bulkImportAllowed
      lastPaymentAttempt
      targetSubscriptionType
      lastChangeSubscriptionDate
      maxUsers
      minUsers
      contractStartDate
      xeroId
      xeroContactId
      xeroInvoiceId
      lastXeroBillingDate
      billingProvider
      supportHours
      supportHoursUsed
      reservedComputeAllocation
      baseModel
      domain
      trainingConfig {
        trainingIterations
        trainingIterationsNLP
        trainingIterationsRC
        trainingEpochsNLP
        trainingEpochsRC
        trainingEpochsGN
        maxStepsNLP
        patienceNLP
        learningRateNLP
        learningRateRC
        testSizeNLP
        testSizeRC
        batchSizeNLP
        batchSizeRC
        datasetTestSizeThresholdNLP
        datasetTestSizeThresholdRC
        learningRateGN
        testSizeGN
        batchSizeGN
        datasetTestSizeThresholdGN
        enableManagedSpotTraining
        maxRuntimeWaitTime
        maxRuntime
        includeReadComprehensionDataInTraining
        generateDockerImageForRCengine
        generateDockerImageForNLPengine
        generateDockerImageForGNengine
        emailsListForTrainingConfirmation
        maxQueueWaitTime
      }
      parsingConfig {
        questionsLimit
        answerAsNER
        answerByParagraph
        uniqueAnswer
        isSentenceSplitEnabled
        isImplicitSelfEnabled
        temperature
        maxTokens
        topP
        topK
        qaDocTopK
        frequencyPenalty
        presencePenalty
        qaTopP
        qaTopK
        qaMaxTokens
        qaTemperature
        qaFrequencyPenalty
        qaPresencePenalty
        qaReplyOutsidePassage
        qaAiKnowledge
        qaInhibitionPassage
        qaEnhancementPassage
        qaRole
        qaDefaultAnswer
        qaStopSequence
        stopSequence
        stopPrompt
        qaExamples {
          question
          answer
        }
        qaBlender
        agcEnabled
      }
      notificationConfig {
        emailsList
        emailOnTrainingCompleted
        emailOnBatchCompleted
        emailOnBatchFailed
        emailOnBatchStart
        emailOnTrainingFailed
        emailOnTrainingStart
        notifyAllUsersInWorkspace
        notifyOnThreasholdConsumption
        notificationThresholdConsumption
      }
      embeddingConfig {
        maxChunkWords
        maxOverlapSentences
        chunkingStrategy
        imageExtractionStrategy
        minImageWidth
        minImageHeight
        aspectRatioMin
        aspectRatioMax
      }
      customGenerationConfig {
        styles
        domains
        scopes
        prompts {
          type
          label
          promptLength
          promptPlaceholder
          interpolationString
        }
        hasTopicsContext
        topics
        docTopK
        topK
        blender
        mode
        aiKnowledge
        compressor
      }
      customImageRecognitionModel
      customVectorDB
      workspaceAgents {
        items {
          id
          type
          label
          description
          interpolationString
          emoji
          color
          darkColor
          icon
          largeLogo
          icoUrl
          logoBackground
          darkLogoBackground
          messageOnLaunch
          messagesOnLaunch
          rotateMessagesOnLaunch
          rotateMessagesOnLaunchInterval
          placeholderMessageOnLoading
          dynamicPlaceholderMessageOnLoading
          customGreetingInstructions
          customConclusionInstructions
          customChartingInstructions
          customSummarisationInstructions
          customImagesInstructions
          customToolingInstructions
          placeholderInputMessage
          openByDefault
          agenticCodingModel
          disclaimer
          showDocumentsReferences
          isDefault
          hasMemory
          hasImages
          promptTopKeywords
          keyWordsForKnowledgeBase
          hasTopicsContext
          hasFunctions
          advancedLanguageDetection
          allowedTopics
          staticDocs
          defaultAnswer
          noKnowledgeDefaultAnswer
          quickQuestions
          recencyImportance
          maxRecencyIncrease
          recencyTopKIncreaseFactor
          stopSequence
          enhancementPassage
          inhibitionPassage
          pertinencePassage
          goals
          qaUrl
          topK
          mode
          showCodeInExecution
          hideReasoning
          charting
          summarisation
          compressor
          docTopK
          minRetrievalScore
          timeSignificance
          hasModeration
          customModerations
          moderationMessage
          languageDetectionConfidence
          maxHistory
          maxTokens
          topicEnhancer
          maxTopics
          blender
          temperature
          seed
          version
          subject
          workspaceID
          createdBy
          updatedBy
          agentFunctions
          isGlobal
          promptBuffering
          functionContext
          plainTextOutput
          chainOfThoughts
          treeOfThoughts
          extendedOutput
          agentType
          agentsPool
          mcps
          maxPlanningSteps
          maxBrowserSteps
          virtualDesktopInstructions
          planningInstructions
          plannerExecutionAttempts
          plannerRequiresApprovalForPlanExecution
          plannerEmailOnApprovalRequest
          plannerEmailOnFailedPlan
          plannerEmailOnCompletedPlan
          plannerAutoAgentSpawn
          plannerRetainsSpawnedAgents
          plannerPromptsAgentsProgrammatically
          plannerDeepThinking
          allowReplanning
          plannerProceedsWhenImprovementsRequired
          plannerApproverEmails
          reviewInstructions
          showReferencesToInternalDocs
          showCitations
          forceJsonOutput
          agenticRAG
          preventWidgetUsage
          allowFeedback
          generateExtendedReport
          showTimeForResponse
          showDetectedLanguage
          showRoutedModel
          isMultiLanguageEnabled
          hasMath
          hasCode
          hasComputer
          hasNER
          restrictedAccess
          restrictedAccessUsers
          splashTitle
          showSplashWhenEmpty
          llmEndpoint
          llmUrl
          llmUrlStatus
          llmUrlType
          llmBaseModel
          llmProvider
          llmTopK
          llmSeed
          forcedTheme
          adverserialProvider
          adverserialModel
          functionCallingProvider
          functionCallingModel
          visionProvider
          visionModel
          browserProvider
          browserModel
          videoGenerationProvider
          videoGenerationModel
          showAgentName
          allowImagesUpload
          allowVideosUpload
          allowAudiosUpload
          allowDocsUpload
          allowImagesGeneration
          baseImageGenerationModel
          maxImagesGenerated
          advancedImageGeneration
          allowVideosGeneration
          allowAudiosGeneration
          allowIntrospection
          voiceFileKey
          audiosGenerationTtsModel
          audiosGenerationVoiceName
          audiosGenerationSpeechMode
          allowInternetSearch
          bannedDomains
          maxUrlsForInternetSearch
          allowDeepInternetSearch
          internetSearchModes
          internetSearchLocation
          autoVoiceMode
          voiceSensitivity
          keywordsWeightInRetrieval
          customCodeExecutionEnvironments
          phoneNumberAsSender
          whatsappNumberAsSender
          emailAsSender
          communicationServices
          channelCallbackDelay
          ephemeralAgent
          parentAgentID
          parentChatID
          minimumSubscriptionType
          clonedAgentID
          clonedAgentIDIcon
          hasContentCreation
          hasEntityExtraction
          department
          metadata
          allowEmailToAgent
          allowedEmails
          agentHiringTemplate
          agentDesktopVM
          agentDesktopPortRange
          agentDesktopCredentials
          agentDesktopBrowser
          allow3dModelGeneration
          agentLongTermMemory
          isLongTermMemoryEnabled
          allowExternalAPI
          forceNewThreadOnProgrammaticRequest
          dynamicModelSelectionInstructions
          contextRelevancyRatio
          reasoningBudget
          reasoningMode
          reasoningEffort
          fnReasoningEffort
          agentFnParams
          canvasEnabled
          advancedCompute
          reRank
          minDeepSearchPagesPercentage
          voiceName
          vadThresholds
          analyticsInstructions
          analyticsCustomFields
          alertIDs
          ragInstructions
          allowAskQuestion
          ragSearchStrategy
          minChunksBeforeCompleteness
          ragCompletenessThreshold
          voiceInstructions
          sttModel
          llmVoiceModel
          ttsModel
          defaultVoiceLanguage
          voiceMinSilenceDuration
          voiceMinEndpointingDelay
          voiceMinInterruptionDuration
          enableVoiceIntermissions
          voiceBackgroundNoise
          sipPhoneNumber
          sipDispatchRuleId
          enableInboundSip
          enableOutboundSip
          enableJsonOutput
          jsonOutputStructure
          predictedPlanJson
          useInterleavedReasoning
          interleavedPreset
          maxTotalToolCalls
          maxConsecutiveSameTool
          maxConsecutiveFailures
          regionalEndpoint
          agentVersion
          agentCategoryType
          maxSessionUoI
          maxSessionTurns
          maxSessionMessage
          showWidgetControls
          allowIpRotationViaProxy
          showToolCallsDetailsInWidget
          allowProxyScraping
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      workspaceCustomPrompts {
        items {
          id
          type
          scope
          style
          domain
          label
          promptLength
          promptPlaceholder
          interpolationString
          availableToAgents
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      customQaConfig {
        roles {
          type
          label
          description
          interpolationString
          emoji
          color
          isDefault
          hasMemory
          hasTopicsContext
          allowedTopics
          defaultAnswer
          stopSequence
          enhancementPassage
          inhibitionPassage
          pertinencePassage
          goals
          qaUrl
          topK
          mode
          charting
          summarisation
          compressor
          docTopK
          maxHistory
          maxTokens
          topicEnhancer
          maxTopics
          blender
          temperature
          version
          subject
        }
      }
      aiConsumption {
        generator {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        questioner {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        translator {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        answerer {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        parser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tokenizer {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        embedder {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        detector {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        chatter {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        planner {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        analyser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        code_execution {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        browser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        voice {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tfcode {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tfdesign {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        proxy {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        vectorisation {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        image_extraction {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        support {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        lastUpdate
        requestsLast30Minutes
        requestsLast24Hours
        totalUoI
        totalCostUSD
        familyBudgetUoI
        familyMaxUsers
        childrenCount
        cachedInputTokens
        cacheSavingsUSD
      }
      aggregatedConsumption {
        generator {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        questioner {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        translator {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        answerer {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        parser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tokenizer {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        embedder {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        detector {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        chatter {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        planner {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        analyser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        code_execution {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        browser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        voice {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tfcode {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tfdesign {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        proxy {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        vectorisation {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        image_extraction {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        support {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        lastUpdate
        requestsLast30Minutes
        requestsLast24Hours
        totalUoI
        totalCostUSD
        familyBudgetUoI
        familyMaxUsers
        childrenCount
        cachedInputTokens
        cacheSavingsUSD
      }
      customUoiPrice
      disabled
      subscriptionPricingPlan {
        items {
          id
          type
          subscriptionStatus
          isPredictionOnDemandGlobal
          isTrainingOnDemandGlobal
          predictionRequestsGlobal
          batchRequestsGlobal
          trainingMinutesGlobal
          baseModelGN
          baseModelQA
          baseModelNLP
          maxUsers
          maxPowerUsers
          agcEnabled
          isDownloadModelEnabled
          isDownloadDataEnabled
          isAPIAccessEnabled
          isBatchJobsEnabled
          isSentimentReviewerEnabled
          isBusinessAnalystEnabled
          isContentCreatorEnabled
          isPriorityTrainingEnabled
          isPredictionGPUAccelerationEnabledGlobal
          isPredictionGPUAccelerationEnabledRC
          isPredictionGPUAccelerationEnabledNLP
          maxMrcDocs
          maxAgents
          maxSites
          maxBenchmarks
          predictionRequestsAPI
          accuracyModelEnabled
          isTrainingNLPEnabled
          isTrainingQAEnabled
          isTrainingGNEnabled
          isLongTermMemoryEnabled
          isFunctionsEnabled
          isDBFunctionsEnabled
          isHtmlFunctionsEnabled
          isSitesBindingEnabled
          isAgentsSecurityEnabled
          isWidgetChatsHistoryEnabled
          maxRequests30Minutes
          maxRequests24Hours
          defaultSupportHours
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      folders {
        items {
          id
          owner
          name
          description
          emoji
          status
          allowedTopics
          parent
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      trainingLogs {
        items {
          id
          owner
          name
          description
          status
          trainingIterations
          lastActivation
          duration
          trainingMeta
          trainingConfig
          workspaceID
          type
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      entities {
        items {
          id
          owner
          label
          type
          description
          emoji
          parentEntity
          backgroundColor
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      appLogs {
        items {
          id
          owner
          type
          filename
          event
          status
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      batchJobs {
        items {
          id
          owner
          name
          description
          status
          duration
          batchMeta
          batchConfig
          batchOutput
          workspaceID
          type
          createdBy
          updatedBy
          benchmarkID
          agentID
          agentVersion
          reviewerAgentID
          reviewerAgentVersion
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      dictionaryItems {
        items {
          id
          owner
          sourceLanguage
          targetLanguage
          sourceText
          targetText
          workspaceID
          pos
          description
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      requestsLogs {
        items {
          id
          srtKey
          type
          status
          words
          tokens
          sentences
          artifactsNumber
          modelType
          outputType
          inputTokens
          outputTokens
          totalTokens
          inputCostUSD
          outputCostUSD
          description
          totalCostUSD
          cachedInputTokens
          cacheHitRate
          cacheSavingsUSD
          callType
          callPurpose
          latencyMs
          agentID
          workspaceID
          createdBy
          updatedBy
          creationTime
          isFromToothFairy
          userID
          supportHours
          chatID
          messageID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      communicationServices {
        items {
          id
          workspaceID
          name
          description
          channel
          provider
          senderid
          fromNumber
          tokenSecret
          sipTrunkId
          isActive
          config
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      sites {
        items {
          id
          name
          description
          url
          customSitemap
          workspaceID
          topics
          status
          lastValidationDate
          lastValidationRequested
          validationToken
          allowedPaths
          siteTree
          lastScraped
          skipOwnerValidation
          useProxy
          completion_percentage
          extractImages
          freeRoaming
          scrapingCycle
          imgRetrievalPrompt
          metadata
          createdBy
          updatedBy
          scapablePages
          scrapedPagesCount
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      cronJobs {
        items {
          id
          name
          description
          forcedPrompt
          type
          agentID
          customPromptID
          workspaceID
          timezone
          isActive
          lastRunAt
          nextRunAt
          status
          metadata
          startDate
          endDate
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      customExecutionEnvironments {
        items {
          id
          name
          description
          functionName
          availableLibraries
          ip
          workspaceID
          port
          metadata
          createdBy
          updatedBy
          isGlobal
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      users
      userCognitoIds
      usersAccessLevel {
        items {
          id
          workspaceID
          userID
          userType
          policyID
          favoriteAgents
          recentLocalFolders
          recentFiles
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      workspaceCreationDate
      workspaceModelReady
      enableDeleteFunctionInAgents
      enableUpdateFunctionInAgents
      enableCustomFunctionInAgents
      defaultChatAgent
      defaultBusinessAnalystAgent
      defaultContentCreatorAgent
      isSentimentReviewerEnabled
      isExtendedContentCreatorEnabled
      isExtendedBusinessAnalystReportEnabled
      customIndexedDBendpoint
      createdBy
      updatedBy
      federationMetadataUrl
      federationMetadataUrlStatus
      federationMetadataUrlType
      ssoType
      ssoDomain
      ssoProviderName
      isMultiLanguageEnabled
      customChartingConfig
      twilioConfig
      emailConfig
      isMFAEnabled
      advancedVectorisation
      advancedCompute
      enableAutoInvite
      autoInviteDomain
      autoInviteUserRole
      customMaxPowerUsers
      customUoiBudget
      requestsPer30MinutesFactor
      webhookUrl
      webhookAuthorisationType
      webhookAuthorisationID
      logo
      enforceRegionalModels
      blockedModels
      billingPeriodStart
      billingPeriodEnd
      parentWorkspaceID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateWorkspace = /* GraphQL */ `
  mutation UpdateWorkspace(
    $input: UpdateWorkspaceInput!
    $condition: ModelWorkspaceConditionInput
  ) {
    updateWorkspace(input: $input, condition: $condition) {
      id
      owner
      title
      visibility
      userID
      isMed
      type
      usagePlanID
      workspaceTokenID
      workspaceToken
      subscriptionType
      subscriptionId
      subscriptionStatus
      enableExperimentalFeatures
      utilityEndpoint
      utilityUrl
      utilityUrlStatus
      utilityUrlType
      utilityBaseModel
      utilityProvider
      codingEndpoint
      codingUrl
      codingUrlStatus
      codingUrlType
      codingBaseModel
      codingProvider
      generalPurposeEndpoint
      generalPurposeUrl
      generalPurposeUrlStatus
      generalPurposeUrlType
      generalPurposeBaseModel
      generalPurposeProvider
      qaEnpoint
      qaUrl
      qaUrlStatus
      qaUrlType
      qaBaseModel
      qaProvider
      cnEndpoint
      cnUrl
      cnUrlStatus
      cnUrlType
      cnBaseModel
      cnProvider
      gnEnpoint
      gnUrl
      gnUrlStatus
      gnUrlType
      gnBaseModel
      gnProvider
      nlpEnpoint
      nlpUrl
      nlpUrlStatus
      nlpUrlType
      nlpBaseModel
      nlpProvider
      embeddingEndpoint
      embeddingUrl
      embeddingUrlStatus
      embeddingUrlType
      embeddingBaseModel
      embeddingProvider
      chartingEndpoint
      chartingUrl
      chartingUrlStatus
      chartingUrlType
      chartingBaseModel
      chartingProvider
      imagingEndpoint
      imagingUrl
      imagingUrlStatus
      imagingUrlType
      imagingBaseModel
      imagingProvider
      reasoningEndpoint
      reasoningUrl
      reasoningUrlStatus
      reasoningUrlType
      reasoningBaseModel
      reasoningProvider
      defaultChatVisibility
      billingStatus
      lastBillingDate
      lastConsumptionNotificationDate
      activeUntil
      paymentFailed
      bulkImportAllowed
      lastPaymentAttempt
      targetSubscriptionType
      lastChangeSubscriptionDate
      maxUsers
      minUsers
      contractStartDate
      xeroId
      xeroContactId
      xeroInvoiceId
      lastXeroBillingDate
      billingProvider
      supportHours
      supportHoursUsed
      reservedComputeAllocation
      baseModel
      domain
      trainingConfig {
        trainingIterations
        trainingIterationsNLP
        trainingIterationsRC
        trainingEpochsNLP
        trainingEpochsRC
        trainingEpochsGN
        maxStepsNLP
        patienceNLP
        learningRateNLP
        learningRateRC
        testSizeNLP
        testSizeRC
        batchSizeNLP
        batchSizeRC
        datasetTestSizeThresholdNLP
        datasetTestSizeThresholdRC
        learningRateGN
        testSizeGN
        batchSizeGN
        datasetTestSizeThresholdGN
        enableManagedSpotTraining
        maxRuntimeWaitTime
        maxRuntime
        includeReadComprehensionDataInTraining
        generateDockerImageForRCengine
        generateDockerImageForNLPengine
        generateDockerImageForGNengine
        emailsListForTrainingConfirmation
        maxQueueWaitTime
      }
      parsingConfig {
        questionsLimit
        answerAsNER
        answerByParagraph
        uniqueAnswer
        isSentenceSplitEnabled
        isImplicitSelfEnabled
        temperature
        maxTokens
        topP
        topK
        qaDocTopK
        frequencyPenalty
        presencePenalty
        qaTopP
        qaTopK
        qaMaxTokens
        qaTemperature
        qaFrequencyPenalty
        qaPresencePenalty
        qaReplyOutsidePassage
        qaAiKnowledge
        qaInhibitionPassage
        qaEnhancementPassage
        qaRole
        qaDefaultAnswer
        qaStopSequence
        stopSequence
        stopPrompt
        qaExamples {
          question
          answer
        }
        qaBlender
        agcEnabled
      }
      notificationConfig {
        emailsList
        emailOnTrainingCompleted
        emailOnBatchCompleted
        emailOnBatchFailed
        emailOnBatchStart
        emailOnTrainingFailed
        emailOnTrainingStart
        notifyAllUsersInWorkspace
        notifyOnThreasholdConsumption
        notificationThresholdConsumption
      }
      embeddingConfig {
        maxChunkWords
        maxOverlapSentences
        chunkingStrategy
        imageExtractionStrategy
        minImageWidth
        minImageHeight
        aspectRatioMin
        aspectRatioMax
      }
      customGenerationConfig {
        styles
        domains
        scopes
        prompts {
          type
          label
          promptLength
          promptPlaceholder
          interpolationString
        }
        hasTopicsContext
        topics
        docTopK
        topK
        blender
        mode
        aiKnowledge
        compressor
      }
      customImageRecognitionModel
      customVectorDB
      workspaceAgents {
        items {
          id
          type
          label
          description
          interpolationString
          emoji
          color
          darkColor
          icon
          largeLogo
          icoUrl
          logoBackground
          darkLogoBackground
          messageOnLaunch
          messagesOnLaunch
          rotateMessagesOnLaunch
          rotateMessagesOnLaunchInterval
          placeholderMessageOnLoading
          dynamicPlaceholderMessageOnLoading
          customGreetingInstructions
          customConclusionInstructions
          customChartingInstructions
          customSummarisationInstructions
          customImagesInstructions
          customToolingInstructions
          placeholderInputMessage
          openByDefault
          agenticCodingModel
          disclaimer
          showDocumentsReferences
          isDefault
          hasMemory
          hasImages
          promptTopKeywords
          keyWordsForKnowledgeBase
          hasTopicsContext
          hasFunctions
          advancedLanguageDetection
          allowedTopics
          staticDocs
          defaultAnswer
          noKnowledgeDefaultAnswer
          quickQuestions
          recencyImportance
          maxRecencyIncrease
          recencyTopKIncreaseFactor
          stopSequence
          enhancementPassage
          inhibitionPassage
          pertinencePassage
          goals
          qaUrl
          topK
          mode
          showCodeInExecution
          hideReasoning
          charting
          summarisation
          compressor
          docTopK
          minRetrievalScore
          timeSignificance
          hasModeration
          customModerations
          moderationMessage
          languageDetectionConfidence
          maxHistory
          maxTokens
          topicEnhancer
          maxTopics
          blender
          temperature
          seed
          version
          subject
          workspaceID
          createdBy
          updatedBy
          agentFunctions
          isGlobal
          promptBuffering
          functionContext
          plainTextOutput
          chainOfThoughts
          treeOfThoughts
          extendedOutput
          agentType
          agentsPool
          mcps
          maxPlanningSteps
          maxBrowserSteps
          virtualDesktopInstructions
          planningInstructions
          plannerExecutionAttempts
          plannerRequiresApprovalForPlanExecution
          plannerEmailOnApprovalRequest
          plannerEmailOnFailedPlan
          plannerEmailOnCompletedPlan
          plannerAutoAgentSpawn
          plannerRetainsSpawnedAgents
          plannerPromptsAgentsProgrammatically
          plannerDeepThinking
          allowReplanning
          plannerProceedsWhenImprovementsRequired
          plannerApproverEmails
          reviewInstructions
          showReferencesToInternalDocs
          showCitations
          forceJsonOutput
          agenticRAG
          preventWidgetUsage
          allowFeedback
          generateExtendedReport
          showTimeForResponse
          showDetectedLanguage
          showRoutedModel
          isMultiLanguageEnabled
          hasMath
          hasCode
          hasComputer
          hasNER
          restrictedAccess
          restrictedAccessUsers
          splashTitle
          showSplashWhenEmpty
          llmEndpoint
          llmUrl
          llmUrlStatus
          llmUrlType
          llmBaseModel
          llmProvider
          llmTopK
          llmSeed
          forcedTheme
          adverserialProvider
          adverserialModel
          functionCallingProvider
          functionCallingModel
          visionProvider
          visionModel
          browserProvider
          browserModel
          videoGenerationProvider
          videoGenerationModel
          showAgentName
          allowImagesUpload
          allowVideosUpload
          allowAudiosUpload
          allowDocsUpload
          allowImagesGeneration
          baseImageGenerationModel
          maxImagesGenerated
          advancedImageGeneration
          allowVideosGeneration
          allowAudiosGeneration
          allowIntrospection
          voiceFileKey
          audiosGenerationTtsModel
          audiosGenerationVoiceName
          audiosGenerationSpeechMode
          allowInternetSearch
          bannedDomains
          maxUrlsForInternetSearch
          allowDeepInternetSearch
          internetSearchModes
          internetSearchLocation
          autoVoiceMode
          voiceSensitivity
          keywordsWeightInRetrieval
          customCodeExecutionEnvironments
          phoneNumberAsSender
          whatsappNumberAsSender
          emailAsSender
          communicationServices
          channelCallbackDelay
          ephemeralAgent
          parentAgentID
          parentChatID
          minimumSubscriptionType
          clonedAgentID
          clonedAgentIDIcon
          hasContentCreation
          hasEntityExtraction
          department
          metadata
          allowEmailToAgent
          allowedEmails
          agentHiringTemplate
          agentDesktopVM
          agentDesktopPortRange
          agentDesktopCredentials
          agentDesktopBrowser
          allow3dModelGeneration
          agentLongTermMemory
          isLongTermMemoryEnabled
          allowExternalAPI
          forceNewThreadOnProgrammaticRequest
          dynamicModelSelectionInstructions
          contextRelevancyRatio
          reasoningBudget
          reasoningMode
          reasoningEffort
          fnReasoningEffort
          agentFnParams
          canvasEnabled
          advancedCompute
          reRank
          minDeepSearchPagesPercentage
          voiceName
          vadThresholds
          analyticsInstructions
          analyticsCustomFields
          alertIDs
          ragInstructions
          allowAskQuestion
          ragSearchStrategy
          minChunksBeforeCompleteness
          ragCompletenessThreshold
          voiceInstructions
          sttModel
          llmVoiceModel
          ttsModel
          defaultVoiceLanguage
          voiceMinSilenceDuration
          voiceMinEndpointingDelay
          voiceMinInterruptionDuration
          enableVoiceIntermissions
          voiceBackgroundNoise
          sipPhoneNumber
          sipDispatchRuleId
          enableInboundSip
          enableOutboundSip
          enableJsonOutput
          jsonOutputStructure
          predictedPlanJson
          useInterleavedReasoning
          interleavedPreset
          maxTotalToolCalls
          maxConsecutiveSameTool
          maxConsecutiveFailures
          regionalEndpoint
          agentVersion
          agentCategoryType
          maxSessionUoI
          maxSessionTurns
          maxSessionMessage
          showWidgetControls
          allowIpRotationViaProxy
          showToolCallsDetailsInWidget
          allowProxyScraping
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      workspaceCustomPrompts {
        items {
          id
          type
          scope
          style
          domain
          label
          promptLength
          promptPlaceholder
          interpolationString
          availableToAgents
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      customQaConfig {
        roles {
          type
          label
          description
          interpolationString
          emoji
          color
          isDefault
          hasMemory
          hasTopicsContext
          allowedTopics
          defaultAnswer
          stopSequence
          enhancementPassage
          inhibitionPassage
          pertinencePassage
          goals
          qaUrl
          topK
          mode
          charting
          summarisation
          compressor
          docTopK
          maxHistory
          maxTokens
          topicEnhancer
          maxTopics
          blender
          temperature
          version
          subject
        }
      }
      aiConsumption {
        generator {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        questioner {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        translator {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        answerer {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        parser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tokenizer {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        embedder {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        detector {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        chatter {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        planner {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        analyser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        code_execution {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        browser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        voice {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tfcode {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tfdesign {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        proxy {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        vectorisation {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        image_extraction {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        support {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        lastUpdate
        requestsLast30Minutes
        requestsLast24Hours
        totalUoI
        totalCostUSD
        familyBudgetUoI
        familyMaxUsers
        childrenCount
        cachedInputTokens
        cacheSavingsUSD
      }
      aggregatedConsumption {
        generator {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        questioner {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        translator {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        answerer {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        parser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tokenizer {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        embedder {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        detector {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        chatter {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        planner {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        analyser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        code_execution {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        browser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        voice {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tfcode {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tfdesign {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        proxy {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        vectorisation {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        image_extraction {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        support {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        lastUpdate
        requestsLast30Minutes
        requestsLast24Hours
        totalUoI
        totalCostUSD
        familyBudgetUoI
        familyMaxUsers
        childrenCount
        cachedInputTokens
        cacheSavingsUSD
      }
      customUoiPrice
      disabled
      subscriptionPricingPlan {
        items {
          id
          type
          subscriptionStatus
          isPredictionOnDemandGlobal
          isTrainingOnDemandGlobal
          predictionRequestsGlobal
          batchRequestsGlobal
          trainingMinutesGlobal
          baseModelGN
          baseModelQA
          baseModelNLP
          maxUsers
          maxPowerUsers
          agcEnabled
          isDownloadModelEnabled
          isDownloadDataEnabled
          isAPIAccessEnabled
          isBatchJobsEnabled
          isSentimentReviewerEnabled
          isBusinessAnalystEnabled
          isContentCreatorEnabled
          isPriorityTrainingEnabled
          isPredictionGPUAccelerationEnabledGlobal
          isPredictionGPUAccelerationEnabledRC
          isPredictionGPUAccelerationEnabledNLP
          maxMrcDocs
          maxAgents
          maxSites
          maxBenchmarks
          predictionRequestsAPI
          accuracyModelEnabled
          isTrainingNLPEnabled
          isTrainingQAEnabled
          isTrainingGNEnabled
          isLongTermMemoryEnabled
          isFunctionsEnabled
          isDBFunctionsEnabled
          isHtmlFunctionsEnabled
          isSitesBindingEnabled
          isAgentsSecurityEnabled
          isWidgetChatsHistoryEnabled
          maxRequests30Minutes
          maxRequests24Hours
          defaultSupportHours
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      folders {
        items {
          id
          owner
          name
          description
          emoji
          status
          allowedTopics
          parent
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      trainingLogs {
        items {
          id
          owner
          name
          description
          status
          trainingIterations
          lastActivation
          duration
          trainingMeta
          trainingConfig
          workspaceID
          type
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      entities {
        items {
          id
          owner
          label
          type
          description
          emoji
          parentEntity
          backgroundColor
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      appLogs {
        items {
          id
          owner
          type
          filename
          event
          status
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      batchJobs {
        items {
          id
          owner
          name
          description
          status
          duration
          batchMeta
          batchConfig
          batchOutput
          workspaceID
          type
          createdBy
          updatedBy
          benchmarkID
          agentID
          agentVersion
          reviewerAgentID
          reviewerAgentVersion
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      dictionaryItems {
        items {
          id
          owner
          sourceLanguage
          targetLanguage
          sourceText
          targetText
          workspaceID
          pos
          description
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      requestsLogs {
        items {
          id
          srtKey
          type
          status
          words
          tokens
          sentences
          artifactsNumber
          modelType
          outputType
          inputTokens
          outputTokens
          totalTokens
          inputCostUSD
          outputCostUSD
          description
          totalCostUSD
          cachedInputTokens
          cacheHitRate
          cacheSavingsUSD
          callType
          callPurpose
          latencyMs
          agentID
          workspaceID
          createdBy
          updatedBy
          creationTime
          isFromToothFairy
          userID
          supportHours
          chatID
          messageID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      communicationServices {
        items {
          id
          workspaceID
          name
          description
          channel
          provider
          senderid
          fromNumber
          tokenSecret
          sipTrunkId
          isActive
          config
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      sites {
        items {
          id
          name
          description
          url
          customSitemap
          workspaceID
          topics
          status
          lastValidationDate
          lastValidationRequested
          validationToken
          allowedPaths
          siteTree
          lastScraped
          skipOwnerValidation
          useProxy
          completion_percentage
          extractImages
          freeRoaming
          scrapingCycle
          imgRetrievalPrompt
          metadata
          createdBy
          updatedBy
          scapablePages
          scrapedPagesCount
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      cronJobs {
        items {
          id
          name
          description
          forcedPrompt
          type
          agentID
          customPromptID
          workspaceID
          timezone
          isActive
          lastRunAt
          nextRunAt
          status
          metadata
          startDate
          endDate
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      customExecutionEnvironments {
        items {
          id
          name
          description
          functionName
          availableLibraries
          ip
          workspaceID
          port
          metadata
          createdBy
          updatedBy
          isGlobal
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      users
      userCognitoIds
      usersAccessLevel {
        items {
          id
          workspaceID
          userID
          userType
          policyID
          favoriteAgents
          recentLocalFolders
          recentFiles
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      workspaceCreationDate
      workspaceModelReady
      enableDeleteFunctionInAgents
      enableUpdateFunctionInAgents
      enableCustomFunctionInAgents
      defaultChatAgent
      defaultBusinessAnalystAgent
      defaultContentCreatorAgent
      isSentimentReviewerEnabled
      isExtendedContentCreatorEnabled
      isExtendedBusinessAnalystReportEnabled
      customIndexedDBendpoint
      createdBy
      updatedBy
      federationMetadataUrl
      federationMetadataUrlStatus
      federationMetadataUrlType
      ssoType
      ssoDomain
      ssoProviderName
      isMultiLanguageEnabled
      customChartingConfig
      twilioConfig
      emailConfig
      isMFAEnabled
      advancedVectorisation
      advancedCompute
      enableAutoInvite
      autoInviteDomain
      autoInviteUserRole
      customMaxPowerUsers
      customUoiBudget
      requestsPer30MinutesFactor
      webhookUrl
      webhookAuthorisationType
      webhookAuthorisationID
      logo
      enforceRegionalModels
      blockedModels
      billingPeriodStart
      billingPeriodEnd
      parentWorkspaceID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteWorkspace = /* GraphQL */ `
  mutation DeleteWorkspace(
    $input: DeleteWorkspaceInput!
    $condition: ModelWorkspaceConditionInput
  ) {
    deleteWorkspace(input: $input, condition: $condition) {
      id
      owner
      title
      visibility
      userID
      isMed
      type
      usagePlanID
      workspaceTokenID
      workspaceToken
      subscriptionType
      subscriptionId
      subscriptionStatus
      enableExperimentalFeatures
      utilityEndpoint
      utilityUrl
      utilityUrlStatus
      utilityUrlType
      utilityBaseModel
      utilityProvider
      codingEndpoint
      codingUrl
      codingUrlStatus
      codingUrlType
      codingBaseModel
      codingProvider
      generalPurposeEndpoint
      generalPurposeUrl
      generalPurposeUrlStatus
      generalPurposeUrlType
      generalPurposeBaseModel
      generalPurposeProvider
      qaEnpoint
      qaUrl
      qaUrlStatus
      qaUrlType
      qaBaseModel
      qaProvider
      cnEndpoint
      cnUrl
      cnUrlStatus
      cnUrlType
      cnBaseModel
      cnProvider
      gnEnpoint
      gnUrl
      gnUrlStatus
      gnUrlType
      gnBaseModel
      gnProvider
      nlpEnpoint
      nlpUrl
      nlpUrlStatus
      nlpUrlType
      nlpBaseModel
      nlpProvider
      embeddingEndpoint
      embeddingUrl
      embeddingUrlStatus
      embeddingUrlType
      embeddingBaseModel
      embeddingProvider
      chartingEndpoint
      chartingUrl
      chartingUrlStatus
      chartingUrlType
      chartingBaseModel
      chartingProvider
      imagingEndpoint
      imagingUrl
      imagingUrlStatus
      imagingUrlType
      imagingBaseModel
      imagingProvider
      reasoningEndpoint
      reasoningUrl
      reasoningUrlStatus
      reasoningUrlType
      reasoningBaseModel
      reasoningProvider
      defaultChatVisibility
      billingStatus
      lastBillingDate
      lastConsumptionNotificationDate
      activeUntil
      paymentFailed
      bulkImportAllowed
      lastPaymentAttempt
      targetSubscriptionType
      lastChangeSubscriptionDate
      maxUsers
      minUsers
      contractStartDate
      xeroId
      xeroContactId
      xeroInvoiceId
      lastXeroBillingDate
      billingProvider
      supportHours
      supportHoursUsed
      reservedComputeAllocation
      baseModel
      domain
      trainingConfig {
        trainingIterations
        trainingIterationsNLP
        trainingIterationsRC
        trainingEpochsNLP
        trainingEpochsRC
        trainingEpochsGN
        maxStepsNLP
        patienceNLP
        learningRateNLP
        learningRateRC
        testSizeNLP
        testSizeRC
        batchSizeNLP
        batchSizeRC
        datasetTestSizeThresholdNLP
        datasetTestSizeThresholdRC
        learningRateGN
        testSizeGN
        batchSizeGN
        datasetTestSizeThresholdGN
        enableManagedSpotTraining
        maxRuntimeWaitTime
        maxRuntime
        includeReadComprehensionDataInTraining
        generateDockerImageForRCengine
        generateDockerImageForNLPengine
        generateDockerImageForGNengine
        emailsListForTrainingConfirmation
        maxQueueWaitTime
      }
      parsingConfig {
        questionsLimit
        answerAsNER
        answerByParagraph
        uniqueAnswer
        isSentenceSplitEnabled
        isImplicitSelfEnabled
        temperature
        maxTokens
        topP
        topK
        qaDocTopK
        frequencyPenalty
        presencePenalty
        qaTopP
        qaTopK
        qaMaxTokens
        qaTemperature
        qaFrequencyPenalty
        qaPresencePenalty
        qaReplyOutsidePassage
        qaAiKnowledge
        qaInhibitionPassage
        qaEnhancementPassage
        qaRole
        qaDefaultAnswer
        qaStopSequence
        stopSequence
        stopPrompt
        qaExamples {
          question
          answer
        }
        qaBlender
        agcEnabled
      }
      notificationConfig {
        emailsList
        emailOnTrainingCompleted
        emailOnBatchCompleted
        emailOnBatchFailed
        emailOnBatchStart
        emailOnTrainingFailed
        emailOnTrainingStart
        notifyAllUsersInWorkspace
        notifyOnThreasholdConsumption
        notificationThresholdConsumption
      }
      embeddingConfig {
        maxChunkWords
        maxOverlapSentences
        chunkingStrategy
        imageExtractionStrategy
        minImageWidth
        minImageHeight
        aspectRatioMin
        aspectRatioMax
      }
      customGenerationConfig {
        styles
        domains
        scopes
        prompts {
          type
          label
          promptLength
          promptPlaceholder
          interpolationString
        }
        hasTopicsContext
        topics
        docTopK
        topK
        blender
        mode
        aiKnowledge
        compressor
      }
      customImageRecognitionModel
      customVectorDB
      workspaceAgents {
        items {
          id
          type
          label
          description
          interpolationString
          emoji
          color
          darkColor
          icon
          largeLogo
          icoUrl
          logoBackground
          darkLogoBackground
          messageOnLaunch
          messagesOnLaunch
          rotateMessagesOnLaunch
          rotateMessagesOnLaunchInterval
          placeholderMessageOnLoading
          dynamicPlaceholderMessageOnLoading
          customGreetingInstructions
          customConclusionInstructions
          customChartingInstructions
          customSummarisationInstructions
          customImagesInstructions
          customToolingInstructions
          placeholderInputMessage
          openByDefault
          agenticCodingModel
          disclaimer
          showDocumentsReferences
          isDefault
          hasMemory
          hasImages
          promptTopKeywords
          keyWordsForKnowledgeBase
          hasTopicsContext
          hasFunctions
          advancedLanguageDetection
          allowedTopics
          staticDocs
          defaultAnswer
          noKnowledgeDefaultAnswer
          quickQuestions
          recencyImportance
          maxRecencyIncrease
          recencyTopKIncreaseFactor
          stopSequence
          enhancementPassage
          inhibitionPassage
          pertinencePassage
          goals
          qaUrl
          topK
          mode
          showCodeInExecution
          hideReasoning
          charting
          summarisation
          compressor
          docTopK
          minRetrievalScore
          timeSignificance
          hasModeration
          customModerations
          moderationMessage
          languageDetectionConfidence
          maxHistory
          maxTokens
          topicEnhancer
          maxTopics
          blender
          temperature
          seed
          version
          subject
          workspaceID
          createdBy
          updatedBy
          agentFunctions
          isGlobal
          promptBuffering
          functionContext
          plainTextOutput
          chainOfThoughts
          treeOfThoughts
          extendedOutput
          agentType
          agentsPool
          mcps
          maxPlanningSteps
          maxBrowserSteps
          virtualDesktopInstructions
          planningInstructions
          plannerExecutionAttempts
          plannerRequiresApprovalForPlanExecution
          plannerEmailOnApprovalRequest
          plannerEmailOnFailedPlan
          plannerEmailOnCompletedPlan
          plannerAutoAgentSpawn
          plannerRetainsSpawnedAgents
          plannerPromptsAgentsProgrammatically
          plannerDeepThinking
          allowReplanning
          plannerProceedsWhenImprovementsRequired
          plannerApproverEmails
          reviewInstructions
          showReferencesToInternalDocs
          showCitations
          forceJsonOutput
          agenticRAG
          preventWidgetUsage
          allowFeedback
          generateExtendedReport
          showTimeForResponse
          showDetectedLanguage
          showRoutedModel
          isMultiLanguageEnabled
          hasMath
          hasCode
          hasComputer
          hasNER
          restrictedAccess
          restrictedAccessUsers
          splashTitle
          showSplashWhenEmpty
          llmEndpoint
          llmUrl
          llmUrlStatus
          llmUrlType
          llmBaseModel
          llmProvider
          llmTopK
          llmSeed
          forcedTheme
          adverserialProvider
          adverserialModel
          functionCallingProvider
          functionCallingModel
          visionProvider
          visionModel
          browserProvider
          browserModel
          videoGenerationProvider
          videoGenerationModel
          showAgentName
          allowImagesUpload
          allowVideosUpload
          allowAudiosUpload
          allowDocsUpload
          allowImagesGeneration
          baseImageGenerationModel
          maxImagesGenerated
          advancedImageGeneration
          allowVideosGeneration
          allowAudiosGeneration
          allowIntrospection
          voiceFileKey
          audiosGenerationTtsModel
          audiosGenerationVoiceName
          audiosGenerationSpeechMode
          allowInternetSearch
          bannedDomains
          maxUrlsForInternetSearch
          allowDeepInternetSearch
          internetSearchModes
          internetSearchLocation
          autoVoiceMode
          voiceSensitivity
          keywordsWeightInRetrieval
          customCodeExecutionEnvironments
          phoneNumberAsSender
          whatsappNumberAsSender
          emailAsSender
          communicationServices
          channelCallbackDelay
          ephemeralAgent
          parentAgentID
          parentChatID
          minimumSubscriptionType
          clonedAgentID
          clonedAgentIDIcon
          hasContentCreation
          hasEntityExtraction
          department
          metadata
          allowEmailToAgent
          allowedEmails
          agentHiringTemplate
          agentDesktopVM
          agentDesktopPortRange
          agentDesktopCredentials
          agentDesktopBrowser
          allow3dModelGeneration
          agentLongTermMemory
          isLongTermMemoryEnabled
          allowExternalAPI
          forceNewThreadOnProgrammaticRequest
          dynamicModelSelectionInstructions
          contextRelevancyRatio
          reasoningBudget
          reasoningMode
          reasoningEffort
          fnReasoningEffort
          agentFnParams
          canvasEnabled
          advancedCompute
          reRank
          minDeepSearchPagesPercentage
          voiceName
          vadThresholds
          analyticsInstructions
          analyticsCustomFields
          alertIDs
          ragInstructions
          allowAskQuestion
          ragSearchStrategy
          minChunksBeforeCompleteness
          ragCompletenessThreshold
          voiceInstructions
          sttModel
          llmVoiceModel
          ttsModel
          defaultVoiceLanguage
          voiceMinSilenceDuration
          voiceMinEndpointingDelay
          voiceMinInterruptionDuration
          enableVoiceIntermissions
          voiceBackgroundNoise
          sipPhoneNumber
          sipDispatchRuleId
          enableInboundSip
          enableOutboundSip
          enableJsonOutput
          jsonOutputStructure
          predictedPlanJson
          useInterleavedReasoning
          interleavedPreset
          maxTotalToolCalls
          maxConsecutiveSameTool
          maxConsecutiveFailures
          regionalEndpoint
          agentVersion
          agentCategoryType
          maxSessionUoI
          maxSessionTurns
          maxSessionMessage
          showWidgetControls
          allowIpRotationViaProxy
          showToolCallsDetailsInWidget
          allowProxyScraping
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      workspaceCustomPrompts {
        items {
          id
          type
          scope
          style
          domain
          label
          promptLength
          promptPlaceholder
          interpolationString
          availableToAgents
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      customQaConfig {
        roles {
          type
          label
          description
          interpolationString
          emoji
          color
          isDefault
          hasMemory
          hasTopicsContext
          allowedTopics
          defaultAnswer
          stopSequence
          enhancementPassage
          inhibitionPassage
          pertinencePassage
          goals
          qaUrl
          topK
          mode
          charting
          summarisation
          compressor
          docTopK
          maxHistory
          maxTokens
          topicEnhancer
          maxTopics
          blender
          temperature
          version
          subject
        }
      }
      aiConsumption {
        generator {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        questioner {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        translator {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        answerer {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        parser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tokenizer {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        embedder {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        detector {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        chatter {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        planner {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        analyser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        code_execution {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        browser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        voice {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tfcode {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tfdesign {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        proxy {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        vectorisation {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        image_extraction {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        support {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        lastUpdate
        requestsLast30Minutes
        requestsLast24Hours
        totalUoI
        totalCostUSD
        familyBudgetUoI
        familyMaxUsers
        childrenCount
        cachedInputTokens
        cacheSavingsUSD
      }
      aggregatedConsumption {
        generator {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        questioner {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        translator {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        answerer {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        parser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tokenizer {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        embedder {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        detector {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        chatter {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        planner {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        analyser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        code_execution {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        browser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        voice {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tfcode {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tfdesign {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        proxy {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        vectorisation {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        image_extraction {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        support {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        lastUpdate
        requestsLast30Minutes
        requestsLast24Hours
        totalUoI
        totalCostUSD
        familyBudgetUoI
        familyMaxUsers
        childrenCount
        cachedInputTokens
        cacheSavingsUSD
      }
      customUoiPrice
      disabled
      subscriptionPricingPlan {
        items {
          id
          type
          subscriptionStatus
          isPredictionOnDemandGlobal
          isTrainingOnDemandGlobal
          predictionRequestsGlobal
          batchRequestsGlobal
          trainingMinutesGlobal
          baseModelGN
          baseModelQA
          baseModelNLP
          maxUsers
          maxPowerUsers
          agcEnabled
          isDownloadModelEnabled
          isDownloadDataEnabled
          isAPIAccessEnabled
          isBatchJobsEnabled
          isSentimentReviewerEnabled
          isBusinessAnalystEnabled
          isContentCreatorEnabled
          isPriorityTrainingEnabled
          isPredictionGPUAccelerationEnabledGlobal
          isPredictionGPUAccelerationEnabledRC
          isPredictionGPUAccelerationEnabledNLP
          maxMrcDocs
          maxAgents
          maxSites
          maxBenchmarks
          predictionRequestsAPI
          accuracyModelEnabled
          isTrainingNLPEnabled
          isTrainingQAEnabled
          isTrainingGNEnabled
          isLongTermMemoryEnabled
          isFunctionsEnabled
          isDBFunctionsEnabled
          isHtmlFunctionsEnabled
          isSitesBindingEnabled
          isAgentsSecurityEnabled
          isWidgetChatsHistoryEnabled
          maxRequests30Minutes
          maxRequests24Hours
          defaultSupportHours
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      folders {
        items {
          id
          owner
          name
          description
          emoji
          status
          allowedTopics
          parent
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      trainingLogs {
        items {
          id
          owner
          name
          description
          status
          trainingIterations
          lastActivation
          duration
          trainingMeta
          trainingConfig
          workspaceID
          type
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      entities {
        items {
          id
          owner
          label
          type
          description
          emoji
          parentEntity
          backgroundColor
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      appLogs {
        items {
          id
          owner
          type
          filename
          event
          status
          workspaceID
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      batchJobs {
        items {
          id
          owner
          name
          description
          status
          duration
          batchMeta
          batchConfig
          batchOutput
          workspaceID
          type
          createdBy
          updatedBy
          benchmarkID
          agentID
          agentVersion
          reviewerAgentID
          reviewerAgentVersion
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      dictionaryItems {
        items {
          id
          owner
          sourceLanguage
          targetLanguage
          sourceText
          targetText
          workspaceID
          pos
          description
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      requestsLogs {
        items {
          id
          srtKey
          type
          status
          words
          tokens
          sentences
          artifactsNumber
          modelType
          outputType
          inputTokens
          outputTokens
          totalTokens
          inputCostUSD
          outputCostUSD
          description
          totalCostUSD
          cachedInputTokens
          cacheHitRate
          cacheSavingsUSD
          callType
          callPurpose
          latencyMs
          agentID
          workspaceID
          createdBy
          updatedBy
          creationTime
          isFromToothFairy
          userID
          supportHours
          chatID
          messageID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      communicationServices {
        items {
          id
          workspaceID
          name
          description
          channel
          provider
          senderid
          fromNumber
          tokenSecret
          sipTrunkId
          isActive
          config
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      sites {
        items {
          id
          name
          description
          url
          customSitemap
          workspaceID
          topics
          status
          lastValidationDate
          lastValidationRequested
          validationToken
          allowedPaths
          siteTree
          lastScraped
          skipOwnerValidation
          useProxy
          completion_percentage
          extractImages
          freeRoaming
          scrapingCycle
          imgRetrievalPrompt
          metadata
          createdBy
          updatedBy
          scapablePages
          scrapedPagesCount
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      cronJobs {
        items {
          id
          name
          description
          forcedPrompt
          type
          agentID
          customPromptID
          workspaceID
          timezone
          isActive
          lastRunAt
          nextRunAt
          status
          metadata
          startDate
          endDate
          createdBy
          updatedBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      customExecutionEnvironments {
        items {
          id
          name
          description
          functionName
          availableLibraries
          ip
          workspaceID
          port
          metadata
          createdBy
          updatedBy
          isGlobal
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      users
      userCognitoIds
      usersAccessLevel {
        items {
          id
          workspaceID
          userID
          userType
          policyID
          favoriteAgents
          recentLocalFolders
          recentFiles
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      workspaceCreationDate
      workspaceModelReady
      enableDeleteFunctionInAgents
      enableUpdateFunctionInAgents
      enableCustomFunctionInAgents
      defaultChatAgent
      defaultBusinessAnalystAgent
      defaultContentCreatorAgent
      isSentimentReviewerEnabled
      isExtendedContentCreatorEnabled
      isExtendedBusinessAnalystReportEnabled
      customIndexedDBendpoint
      createdBy
      updatedBy
      federationMetadataUrl
      federationMetadataUrlStatus
      federationMetadataUrlType
      ssoType
      ssoDomain
      ssoProviderName
      isMultiLanguageEnabled
      customChartingConfig
      twilioConfig
      emailConfig
      isMFAEnabled
      advancedVectorisation
      advancedCompute
      enableAutoInvite
      autoInviteDomain
      autoInviteUserRole
      customMaxPowerUsers
      customUoiBudget
      requestsPer30MinutesFactor
      webhookUrl
      webhookAuthorisationType
      webhookAuthorisationID
      logo
      enforceRegionalModels
      blockedModels
      billingPeriodStart
      billingPeriodEnd
      parentWorkspaceID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createUserPolicy = /* GraphQL */ `
  mutation CreateUserPolicy(
    $input: CreateUserPolicyInput!
    $condition: ModelUserPolicyConditionInput
  ) {
    createUserPolicy(input: $input, condition: $condition) {
      id
      workspaceID
      inheritFrom
      properties
      allowedDocs
      allowedModels
      allowedAgents
      createdBy
      createdAt
      creationTime
      updatedAt
      updatedBy
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateUserPolicy = /* GraphQL */ `
  mutation UpdateUserPolicy(
    $input: UpdateUserPolicyInput!
    $condition: ModelUserPolicyConditionInput
  ) {
    updateUserPolicy(input: $input, condition: $condition) {
      id
      workspaceID
      inheritFrom
      properties
      allowedDocs
      allowedModels
      allowedAgents
      createdBy
      createdAt
      creationTime
      updatedAt
      updatedBy
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteUserPolicy = /* GraphQL */ `
  mutation DeleteUserPolicy(
    $input: DeleteUserPolicyInput!
    $condition: ModelUserPolicyConditionInput
  ) {
    deleteUserPolicy(input: $input, condition: $condition) {
      id
      workspaceID
      inheritFrom
      properties
      allowedDocs
      allowedModels
      allowedAgents
      createdBy
      createdAt
      creationTime
      updatedAt
      updatedBy
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createUserWorkspaceType = /* GraphQL */ `
  mutation CreateUserWorkspaceType(
    $input: CreateUserWorkspaceTypeInput!
    $condition: ModelUserWorkspaceTypeConditionInput
  ) {
    createUserWorkspaceType(input: $input, condition: $condition) {
      id
      workspaceID
      userID
      userType
      policyID
      favoriteAgents
      recentLocalFolders
      recentFiles
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateUserWorkspaceType = /* GraphQL */ `
  mutation UpdateUserWorkspaceType(
    $input: UpdateUserWorkspaceTypeInput!
    $condition: ModelUserWorkspaceTypeConditionInput
  ) {
    updateUserWorkspaceType(input: $input, condition: $condition) {
      id
      workspaceID
      userID
      userType
      policyID
      favoriteAgents
      recentLocalFolders
      recentFiles
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteUserWorkspaceType = /* GraphQL */ `
  mutation DeleteUserWorkspaceType(
    $input: DeleteUserWorkspaceTypeInput!
    $condition: ModelUserWorkspaceTypeConditionInput
  ) {
    deleteUserWorkspaceType(input: $input, condition: $condition) {
      id
      workspaceID
      userID
      userType
      policyID
      favoriteAgents
      recentLocalFolders
      recentFiles
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createAgent = /* GraphQL */ `
  mutation CreateAgent(
    $input: CreateAgentInput!
    $condition: ModelAgentConditionInput
  ) {
    createAgent(input: $input, condition: $condition) {
      id
      type
      label
      description
      interpolationString
      emoji
      color
      darkColor
      icon
      largeLogo
      icoUrl
      logoBackground
      darkLogoBackground
      messageOnLaunch
      messagesOnLaunch
      rotateMessagesOnLaunch
      rotateMessagesOnLaunchInterval
      placeholderMessageOnLoading
      dynamicPlaceholderMessageOnLoading
      customGreetingInstructions
      customConclusionInstructions
      customChartingInstructions
      customSummarisationInstructions
      customImagesInstructions
      customToolingInstructions
      placeholderInputMessage
      openByDefault
      agenticCodingModel
      disclaimer
      showDocumentsReferences
      isDefault
      hasMemory
      hasImages
      promptTopKeywords
      keyWordsForKnowledgeBase
      hasTopicsContext
      hasFunctions
      advancedLanguageDetection
      allowedTopics
      staticDocs
      defaultAnswer
      noKnowledgeDefaultAnswer
      quickQuestions
      recencyImportance
      maxRecencyIncrease
      recencyTopKIncreaseFactor
      stopSequence
      examples {
        question
        answer
      }
      enhancementPassage
      inhibitionPassage
      pertinencePassage
      goals
      qaUrl
      topK
      mode
      showCodeInExecution
      hideReasoning
      charting
      summarisation
      compressor
      docTopK
      minRetrievalScore
      timeSignificance
      hasModeration
      customModerations
      moderationMessage
      languageDetectionConfidence
      maxHistory
      maxTokens
      topicEnhancer
      maxTopics
      blender
      temperature
      seed
      version
      subject
      workspaceID
      createdBy
      updatedBy
      agentFunctions
      isGlobal
      promptBuffering
      functionContext
      plainTextOutput
      chainOfThoughts
      treeOfThoughts
      extendedOutput
      agentType
      agentsPool
      mcps
      maxPlanningSteps
      maxBrowserSteps
      virtualDesktopInstructions
      planningInstructions
      plannerExecutionAttempts
      plannerRequiresApprovalForPlanExecution
      plannerEmailOnApprovalRequest
      plannerEmailOnFailedPlan
      plannerEmailOnCompletedPlan
      plannerAutoAgentSpawn
      plannerRetainsSpawnedAgents
      plannerPromptsAgentsProgrammatically
      plannerDeepThinking
      allowReplanning
      plannerProceedsWhenImprovementsRequired
      plannerApproverEmails
      reviewInstructions
      showReferencesToInternalDocs
      showCitations
      forceJsonOutput
      agenticRAG
      preventWidgetUsage
      allowFeedback
      generateExtendedReport
      showTimeForResponse
      showDetectedLanguage
      showRoutedModel
      isMultiLanguageEnabled
      hasMath
      hasCode
      hasComputer
      hasNER
      restrictedAccess
      restrictedAccessUsers
      splashTitle
      showSplashWhenEmpty
      llmEndpoint
      llmUrl
      llmUrlStatus
      llmUrlType
      llmBaseModel
      llmProvider
      llmTopK
      llmSeed
      forcedTheme
      adverserialProvider
      adverserialModel
      functionCallingProvider
      functionCallingModel
      visionProvider
      visionModel
      browserProvider
      browserModel
      videoGenerationProvider
      videoGenerationModel
      showAgentName
      allowImagesUpload
      allowVideosUpload
      allowAudiosUpload
      allowDocsUpload
      allowImagesGeneration
      baseImageGenerationModel
      maxImagesGenerated
      advancedImageGeneration
      allowVideosGeneration
      allowAudiosGeneration
      allowIntrospection
      voiceFileKey
      audiosGenerationTtsModel
      audiosGenerationVoiceName
      audiosGenerationSpeechMode
      allowInternetSearch
      bannedDomains
      maxUrlsForInternetSearch
      allowDeepInternetSearch
      internetSearchModes
      internetSearchLocation
      autoVoiceMode
      voiceSensitivity
      keywordsWeightInRetrieval
      customCodeExecutionEnvironments
      phoneNumberAsSender
      whatsappNumberAsSender
      emailAsSender
      communicationServices
      channelCallbackDelay
      ephemeralAgent
      parentAgentID
      parentChatID
      minimumSubscriptionType
      clonedAgentID
      clonedAgentIDIcon
      hasContentCreation
      hasEntityExtraction
      department
      metadata
      allowEmailToAgent
      allowedEmails
      agentHiringTemplate
      agentDesktopVM
      agentDesktopPortRange
      agentDesktopCredentials
      agentDesktopBrowser
      allow3dModelGeneration
      agentLongTermMemory
      isLongTermMemoryEnabled
      allowExternalAPI
      forceNewThreadOnProgrammaticRequest
      dynamicModelSelectionInstructions
      contextRelevancyRatio
      reasoningBudget
      reasoningMode
      reasoningEffort
      fnReasoningEffort
      agentFnParams
      canvasEnabled
      advancedCompute
      reRank
      minDeepSearchPagesPercentage
      voiceName
      vadThresholds
      analyticsInstructions
      analyticsCustomFields
      alertIDs
      ragInstructions
      allowAskQuestion
      ragSearchStrategy
      minChunksBeforeCompleteness
      ragCompletenessThreshold
      voiceInstructions
      sttModel
      llmVoiceModel
      ttsModel
      defaultVoiceLanguage
      voiceMinSilenceDuration
      voiceMinEndpointingDelay
      voiceMinInterruptionDuration
      enableVoiceIntermissions
      voiceBackgroundNoise
      sipPhoneNumber
      sipDispatchRuleId
      enableInboundSip
      enableOutboundSip
      enableJsonOutput
      jsonOutputStructure
      predictedPlanJson
      useInterleavedReasoning
      interleavedPreset
      maxTotalToolCalls
      maxConsecutiveSameTool
      maxConsecutiveFailures
      regionalEndpoint
      agentVersion
      agentCategoryType
      maxSessionUoI
      maxSessionTurns
      maxSessionMessage
      showWidgetControls
      allowIpRotationViaProxy
      showToolCallsDetailsInWidget
      allowProxyScraping
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateAgent = /* GraphQL */ `
  mutation UpdateAgent(
    $input: UpdateAgentInput!
    $condition: ModelAgentConditionInput
  ) {
    updateAgent(input: $input, condition: $condition) {
      id
      type
      label
      description
      interpolationString
      emoji
      color
      darkColor
      icon
      largeLogo
      icoUrl
      logoBackground
      darkLogoBackground
      messageOnLaunch
      messagesOnLaunch
      rotateMessagesOnLaunch
      rotateMessagesOnLaunchInterval
      placeholderMessageOnLoading
      dynamicPlaceholderMessageOnLoading
      customGreetingInstructions
      customConclusionInstructions
      customChartingInstructions
      customSummarisationInstructions
      customImagesInstructions
      customToolingInstructions
      placeholderInputMessage
      openByDefault
      agenticCodingModel
      disclaimer
      showDocumentsReferences
      isDefault
      hasMemory
      hasImages
      promptTopKeywords
      keyWordsForKnowledgeBase
      hasTopicsContext
      hasFunctions
      advancedLanguageDetection
      allowedTopics
      staticDocs
      defaultAnswer
      noKnowledgeDefaultAnswer
      quickQuestions
      recencyImportance
      maxRecencyIncrease
      recencyTopKIncreaseFactor
      stopSequence
      examples {
        question
        answer
      }
      enhancementPassage
      inhibitionPassage
      pertinencePassage
      goals
      qaUrl
      topK
      mode
      showCodeInExecution
      hideReasoning
      charting
      summarisation
      compressor
      docTopK
      minRetrievalScore
      timeSignificance
      hasModeration
      customModerations
      moderationMessage
      languageDetectionConfidence
      maxHistory
      maxTokens
      topicEnhancer
      maxTopics
      blender
      temperature
      seed
      version
      subject
      workspaceID
      createdBy
      updatedBy
      agentFunctions
      isGlobal
      promptBuffering
      functionContext
      plainTextOutput
      chainOfThoughts
      treeOfThoughts
      extendedOutput
      agentType
      agentsPool
      mcps
      maxPlanningSteps
      maxBrowserSteps
      virtualDesktopInstructions
      planningInstructions
      plannerExecutionAttempts
      plannerRequiresApprovalForPlanExecution
      plannerEmailOnApprovalRequest
      plannerEmailOnFailedPlan
      plannerEmailOnCompletedPlan
      plannerAutoAgentSpawn
      plannerRetainsSpawnedAgents
      plannerPromptsAgentsProgrammatically
      plannerDeepThinking
      allowReplanning
      plannerProceedsWhenImprovementsRequired
      plannerApproverEmails
      reviewInstructions
      showReferencesToInternalDocs
      showCitations
      forceJsonOutput
      agenticRAG
      preventWidgetUsage
      allowFeedback
      generateExtendedReport
      showTimeForResponse
      showDetectedLanguage
      showRoutedModel
      isMultiLanguageEnabled
      hasMath
      hasCode
      hasComputer
      hasNER
      restrictedAccess
      restrictedAccessUsers
      splashTitle
      showSplashWhenEmpty
      llmEndpoint
      llmUrl
      llmUrlStatus
      llmUrlType
      llmBaseModel
      llmProvider
      llmTopK
      llmSeed
      forcedTheme
      adverserialProvider
      adverserialModel
      functionCallingProvider
      functionCallingModel
      visionProvider
      visionModel
      browserProvider
      browserModel
      videoGenerationProvider
      videoGenerationModel
      showAgentName
      allowImagesUpload
      allowVideosUpload
      allowAudiosUpload
      allowDocsUpload
      allowImagesGeneration
      baseImageGenerationModel
      maxImagesGenerated
      advancedImageGeneration
      allowVideosGeneration
      allowAudiosGeneration
      allowIntrospection
      voiceFileKey
      audiosGenerationTtsModel
      audiosGenerationVoiceName
      audiosGenerationSpeechMode
      allowInternetSearch
      bannedDomains
      maxUrlsForInternetSearch
      allowDeepInternetSearch
      internetSearchModes
      internetSearchLocation
      autoVoiceMode
      voiceSensitivity
      keywordsWeightInRetrieval
      customCodeExecutionEnvironments
      phoneNumberAsSender
      whatsappNumberAsSender
      emailAsSender
      communicationServices
      channelCallbackDelay
      ephemeralAgent
      parentAgentID
      parentChatID
      minimumSubscriptionType
      clonedAgentID
      clonedAgentIDIcon
      hasContentCreation
      hasEntityExtraction
      department
      metadata
      allowEmailToAgent
      allowedEmails
      agentHiringTemplate
      agentDesktopVM
      agentDesktopPortRange
      agentDesktopCredentials
      agentDesktopBrowser
      allow3dModelGeneration
      agentLongTermMemory
      isLongTermMemoryEnabled
      allowExternalAPI
      forceNewThreadOnProgrammaticRequest
      dynamicModelSelectionInstructions
      contextRelevancyRatio
      reasoningBudget
      reasoningMode
      reasoningEffort
      fnReasoningEffort
      agentFnParams
      canvasEnabled
      advancedCompute
      reRank
      minDeepSearchPagesPercentage
      voiceName
      vadThresholds
      analyticsInstructions
      analyticsCustomFields
      alertIDs
      ragInstructions
      allowAskQuestion
      ragSearchStrategy
      minChunksBeforeCompleteness
      ragCompletenessThreshold
      voiceInstructions
      sttModel
      llmVoiceModel
      ttsModel
      defaultVoiceLanguage
      voiceMinSilenceDuration
      voiceMinEndpointingDelay
      voiceMinInterruptionDuration
      enableVoiceIntermissions
      voiceBackgroundNoise
      sipPhoneNumber
      sipDispatchRuleId
      enableInboundSip
      enableOutboundSip
      enableJsonOutput
      jsonOutputStructure
      predictedPlanJson
      useInterleavedReasoning
      interleavedPreset
      maxTotalToolCalls
      maxConsecutiveSameTool
      maxConsecutiveFailures
      regionalEndpoint
      agentVersion
      agentCategoryType
      maxSessionUoI
      maxSessionTurns
      maxSessionMessage
      showWidgetControls
      allowIpRotationViaProxy
      showToolCallsDetailsInWidget
      allowProxyScraping
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteAgent = /* GraphQL */ `
  mutation DeleteAgent(
    $input: DeleteAgentInput!
    $condition: ModelAgentConditionInput
  ) {
    deleteAgent(input: $input, condition: $condition) {
      id
      type
      label
      description
      interpolationString
      emoji
      color
      darkColor
      icon
      largeLogo
      icoUrl
      logoBackground
      darkLogoBackground
      messageOnLaunch
      messagesOnLaunch
      rotateMessagesOnLaunch
      rotateMessagesOnLaunchInterval
      placeholderMessageOnLoading
      dynamicPlaceholderMessageOnLoading
      customGreetingInstructions
      customConclusionInstructions
      customChartingInstructions
      customSummarisationInstructions
      customImagesInstructions
      customToolingInstructions
      placeholderInputMessage
      openByDefault
      agenticCodingModel
      disclaimer
      showDocumentsReferences
      isDefault
      hasMemory
      hasImages
      promptTopKeywords
      keyWordsForKnowledgeBase
      hasTopicsContext
      hasFunctions
      advancedLanguageDetection
      allowedTopics
      staticDocs
      defaultAnswer
      noKnowledgeDefaultAnswer
      quickQuestions
      recencyImportance
      maxRecencyIncrease
      recencyTopKIncreaseFactor
      stopSequence
      examples {
        question
        answer
      }
      enhancementPassage
      inhibitionPassage
      pertinencePassage
      goals
      qaUrl
      topK
      mode
      showCodeInExecution
      hideReasoning
      charting
      summarisation
      compressor
      docTopK
      minRetrievalScore
      timeSignificance
      hasModeration
      customModerations
      moderationMessage
      languageDetectionConfidence
      maxHistory
      maxTokens
      topicEnhancer
      maxTopics
      blender
      temperature
      seed
      version
      subject
      workspaceID
      createdBy
      updatedBy
      agentFunctions
      isGlobal
      promptBuffering
      functionContext
      plainTextOutput
      chainOfThoughts
      treeOfThoughts
      extendedOutput
      agentType
      agentsPool
      mcps
      maxPlanningSteps
      maxBrowserSteps
      virtualDesktopInstructions
      planningInstructions
      plannerExecutionAttempts
      plannerRequiresApprovalForPlanExecution
      plannerEmailOnApprovalRequest
      plannerEmailOnFailedPlan
      plannerEmailOnCompletedPlan
      plannerAutoAgentSpawn
      plannerRetainsSpawnedAgents
      plannerPromptsAgentsProgrammatically
      plannerDeepThinking
      allowReplanning
      plannerProceedsWhenImprovementsRequired
      plannerApproverEmails
      reviewInstructions
      showReferencesToInternalDocs
      showCitations
      forceJsonOutput
      agenticRAG
      preventWidgetUsage
      allowFeedback
      generateExtendedReport
      showTimeForResponse
      showDetectedLanguage
      showRoutedModel
      isMultiLanguageEnabled
      hasMath
      hasCode
      hasComputer
      hasNER
      restrictedAccess
      restrictedAccessUsers
      splashTitle
      showSplashWhenEmpty
      llmEndpoint
      llmUrl
      llmUrlStatus
      llmUrlType
      llmBaseModel
      llmProvider
      llmTopK
      llmSeed
      forcedTheme
      adverserialProvider
      adverserialModel
      functionCallingProvider
      functionCallingModel
      visionProvider
      visionModel
      browserProvider
      browserModel
      videoGenerationProvider
      videoGenerationModel
      showAgentName
      allowImagesUpload
      allowVideosUpload
      allowAudiosUpload
      allowDocsUpload
      allowImagesGeneration
      baseImageGenerationModel
      maxImagesGenerated
      advancedImageGeneration
      allowVideosGeneration
      allowAudiosGeneration
      allowIntrospection
      voiceFileKey
      audiosGenerationTtsModel
      audiosGenerationVoiceName
      audiosGenerationSpeechMode
      allowInternetSearch
      bannedDomains
      maxUrlsForInternetSearch
      allowDeepInternetSearch
      internetSearchModes
      internetSearchLocation
      autoVoiceMode
      voiceSensitivity
      keywordsWeightInRetrieval
      customCodeExecutionEnvironments
      phoneNumberAsSender
      whatsappNumberAsSender
      emailAsSender
      communicationServices
      channelCallbackDelay
      ephemeralAgent
      parentAgentID
      parentChatID
      minimumSubscriptionType
      clonedAgentID
      clonedAgentIDIcon
      hasContentCreation
      hasEntityExtraction
      department
      metadata
      allowEmailToAgent
      allowedEmails
      agentHiringTemplate
      agentDesktopVM
      agentDesktopPortRange
      agentDesktopCredentials
      agentDesktopBrowser
      allow3dModelGeneration
      agentLongTermMemory
      isLongTermMemoryEnabled
      allowExternalAPI
      forceNewThreadOnProgrammaticRequest
      dynamicModelSelectionInstructions
      contextRelevancyRatio
      reasoningBudget
      reasoningMode
      reasoningEffort
      fnReasoningEffort
      agentFnParams
      canvasEnabled
      advancedCompute
      reRank
      minDeepSearchPagesPercentage
      voiceName
      vadThresholds
      analyticsInstructions
      analyticsCustomFields
      alertIDs
      ragInstructions
      allowAskQuestion
      ragSearchStrategy
      minChunksBeforeCompleteness
      ragCompletenessThreshold
      voiceInstructions
      sttModel
      llmVoiceModel
      ttsModel
      defaultVoiceLanguage
      voiceMinSilenceDuration
      voiceMinEndpointingDelay
      voiceMinInterruptionDuration
      enableVoiceIntermissions
      voiceBackgroundNoise
      sipPhoneNumber
      sipDispatchRuleId
      enableInboundSip
      enableOutboundSip
      enableJsonOutput
      jsonOutputStructure
      predictedPlanJson
      useInterleavedReasoning
      interleavedPreset
      maxTotalToolCalls
      maxConsecutiveSameTool
      maxConsecutiveFailures
      regionalEndpoint
      agentVersion
      agentCategoryType
      maxSessionUoI
      maxSessionTurns
      maxSessionMessage
      showWidgetControls
      allowIpRotationViaProxy
      showToolCallsDetailsInWidget
      allowProxyScraping
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createAgentFunction = /* GraphQL */ `
  mutation CreateAgentFunction(
    $input: CreateAgentFunctionInput!
    $condition: ModelAgentFunctionConditionInput
  ) {
    createAgentFunction(input: $input, condition: $condition) {
      id
      name
      description
      parameters
      model
      url
      requestType
      authorisationType
      dependsOnBeforeExecution
      dependsOnAfterExecution
      authorisationKey
      authorisationID
      paramsAsPath
      scope
      jsonPathExtractor
      headers
      staticArgs
      customExecutionCode
      isMCPServer
      isCallbackFn
      isDatabaseScript
      isHtmlFn
      isChatFn
      isHandOffFn
      isCodeTemplate
      isAgentSkill
      codeExecutionEnvironmentID
      onFnCall
      handOffAgent
      handOffToOriginalAgentOnCompletion
      handOffToOriginalAgentOnFailure
      handOffAgentOnCompletion
      handOffAgentOnFailure
      agentSkillScript
      chatScript
      chatAction
      htmlUrl
      htmlScript
      isHtmlRedirectFn
      htmlFormOnSuccessfulSubmitMessage
      htmlFormOnFailedSubmitMessage
      dbSchemaMetadata
      preExecutionScript
      postExecutionScript
      dbScript
      dbConnectionID
      preExecutionFnID
      preExecutionMapping
      OAuthConnectionID
      handedOffToHumanOnCall
      graphqlQuery
      graphqlMutation
      graphqlOperationName
      usersToHandOffTo
      workspaceID
      createdBy
      updatedBy
      isGlobal
      functionVersion
      functionType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateAgentFunction = /* GraphQL */ `
  mutation UpdateAgentFunction(
    $input: UpdateAgentFunctionInput!
    $condition: ModelAgentFunctionConditionInput
  ) {
    updateAgentFunction(input: $input, condition: $condition) {
      id
      name
      description
      parameters
      model
      url
      requestType
      authorisationType
      dependsOnBeforeExecution
      dependsOnAfterExecution
      authorisationKey
      authorisationID
      paramsAsPath
      scope
      jsonPathExtractor
      headers
      staticArgs
      customExecutionCode
      isMCPServer
      isCallbackFn
      isDatabaseScript
      isHtmlFn
      isChatFn
      isHandOffFn
      isCodeTemplate
      isAgentSkill
      codeExecutionEnvironmentID
      onFnCall
      handOffAgent
      handOffToOriginalAgentOnCompletion
      handOffToOriginalAgentOnFailure
      handOffAgentOnCompletion
      handOffAgentOnFailure
      agentSkillScript
      chatScript
      chatAction
      htmlUrl
      htmlScript
      isHtmlRedirectFn
      htmlFormOnSuccessfulSubmitMessage
      htmlFormOnFailedSubmitMessage
      dbSchemaMetadata
      preExecutionScript
      postExecutionScript
      dbScript
      dbConnectionID
      preExecutionFnID
      preExecutionMapping
      OAuthConnectionID
      handedOffToHumanOnCall
      graphqlQuery
      graphqlMutation
      graphqlOperationName
      usersToHandOffTo
      workspaceID
      createdBy
      updatedBy
      isGlobal
      functionVersion
      functionType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteAgentFunction = /* GraphQL */ `
  mutation DeleteAgentFunction(
    $input: DeleteAgentFunctionInput!
    $condition: ModelAgentFunctionConditionInput
  ) {
    deleteAgentFunction(input: $input, condition: $condition) {
      id
      name
      description
      parameters
      model
      url
      requestType
      authorisationType
      dependsOnBeforeExecution
      dependsOnAfterExecution
      authorisationKey
      authorisationID
      paramsAsPath
      scope
      jsonPathExtractor
      headers
      staticArgs
      customExecutionCode
      isMCPServer
      isCallbackFn
      isDatabaseScript
      isHtmlFn
      isChatFn
      isHandOffFn
      isCodeTemplate
      isAgentSkill
      codeExecutionEnvironmentID
      onFnCall
      handOffAgent
      handOffToOriginalAgentOnCompletion
      handOffToOriginalAgentOnFailure
      handOffAgentOnCompletion
      handOffAgentOnFailure
      agentSkillScript
      chatScript
      chatAction
      htmlUrl
      htmlScript
      isHtmlRedirectFn
      htmlFormOnSuccessfulSubmitMessage
      htmlFormOnFailedSubmitMessage
      dbSchemaMetadata
      preExecutionScript
      postExecutionScript
      dbScript
      dbConnectionID
      preExecutionFnID
      preExecutionMapping
      OAuthConnectionID
      handedOffToHumanOnCall
      graphqlQuery
      graphqlMutation
      graphqlOperationName
      usersToHandOffTo
      workspaceID
      createdBy
      updatedBy
      isGlobal
      functionVersion
      functionType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createAuthorisation = /* GraphQL */ `
  mutation CreateAuthorisation(
    $input: CreateAuthorisationInput!
    $condition: ModelAuthorisationConditionInput
  ) {
    createAuthorisation(input: $input, condition: $condition) {
      id
      name
      tokenSecret
      description
      scope
      grantType
      clientId
      clientSecret
      authorizationBaseUrl
      staticArgs
      tokenBaseUrl
      type
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateAuthorisation = /* GraphQL */ `
  mutation UpdateAuthorisation(
    $input: UpdateAuthorisationInput!
    $condition: ModelAuthorisationConditionInput
  ) {
    updateAuthorisation(input: $input, condition: $condition) {
      id
      name
      tokenSecret
      description
      scope
      grantType
      clientId
      clientSecret
      authorizationBaseUrl
      staticArgs
      tokenBaseUrl
      type
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteAuthorisation = /* GraphQL */ `
  mutation DeleteAuthorisation(
    $input: DeleteAuthorisationInput!
    $condition: ModelAuthorisationConditionInput
  ) {
    deleteAuthorisation(input: $input, condition: $condition) {
      id
      name
      tokenSecret
      description
      scope
      grantType
      clientId
      clientSecret
      authorizationBaseUrl
      staticArgs
      tokenBaseUrl
      type
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createHosting = /* GraphQL */ `
  mutation CreateHosting(
    $input: CreateHostingInput!
    $condition: ModelHostingConditionInput
  ) {
    createHosting(input: $input, condition: $condition) {
      id
      name
      description
      tokenSecret
      endpoint
      modelName
      baseModel
      customModel
      apiVersion
      type
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateHosting = /* GraphQL */ `
  mutation UpdateHosting(
    $input: UpdateHostingInput!
    $condition: ModelHostingConditionInput
  ) {
    updateHosting(input: $input, condition: $condition) {
      id
      name
      description
      tokenSecret
      endpoint
      modelName
      baseModel
      customModel
      apiVersion
      type
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteHosting = /* GraphQL */ `
  mutation DeleteHosting(
    $input: DeleteHostingInput!
    $condition: ModelHostingConditionInput
  ) {
    deleteHosting(input: $input, condition: $condition) {
      id
      name
      description
      tokenSecret
      endpoint
      modelName
      baseModel
      customModel
      apiVersion
      type
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createMCP = /* GraphQL */ `
  mutation CreateMCP(
    $input: CreateMCPInput!
    $condition: ModelMCPConditionInput
  ) {
    createMCP(input: $input, condition: $condition) {
      id
      name
      version
      description
      tokenSecret
      endpoint
      toolsAvailable
      resourcesAvailable
      promptsAvailable
      workspaceID
      createdBy
      updatedBy
      isGlobal
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateMCP = /* GraphQL */ `
  mutation UpdateMCP(
    $input: UpdateMCPInput!
    $condition: ModelMCPConditionInput
  ) {
    updateMCP(input: $input, condition: $condition) {
      id
      name
      version
      description
      tokenSecret
      endpoint
      toolsAvailable
      resourcesAvailable
      promptsAvailable
      workspaceID
      createdBy
      updatedBy
      isGlobal
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteMCP = /* GraphQL */ `
  mutation DeleteMCP(
    $input: DeleteMCPInput!
    $condition: ModelMCPConditionInput
  ) {
    deleteMCP(input: $input, condition: $condition) {
      id
      name
      version
      description
      tokenSecret
      endpoint
      toolsAvailable
      resourcesAvailable
      promptsAvailable
      workspaceID
      createdBy
      updatedBy
      isGlobal
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createDatabaseConnection = /* GraphQL */ `
  mutation CreateDatabaseConnection(
    $input: CreateDatabaseConnectionInput!
    $condition: ModelDatabaseConnectionConditionInput
  ) {
    createDatabaseConnection(input: $input, condition: $condition) {
      id
      name
      description
      type
      host
      port
      username
      passwordSecret
      database
      schema
      ssl
      ssh
      sshHost
      sshPort
      sshUsername
      sshPasswordSecret
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateDatabaseConnection = /* GraphQL */ `
  mutation UpdateDatabaseConnection(
    $input: UpdateDatabaseConnectionInput!
    $condition: ModelDatabaseConnectionConditionInput
  ) {
    updateDatabaseConnection(input: $input, condition: $condition) {
      id
      name
      description
      type
      host
      port
      username
      passwordSecret
      database
      schema
      ssl
      ssh
      sshHost
      sshPort
      sshUsername
      sshPasswordSecret
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteDatabaseConnection = /* GraphQL */ `
  mutation DeleteDatabaseConnection(
    $input: DeleteDatabaseConnectionInput!
    $condition: ModelDatabaseConnectionConditionInput
  ) {
    deleteDatabaseConnection(input: $input, condition: $condition) {
      id
      name
      description
      type
      host
      port
      username
      passwordSecret
      database
      schema
      ssl
      ssh
      sshHost
      sshPort
      sshUsername
      sshPasswordSecret
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createUserNotification = /* GraphQL */ `
  mutation CreateUserNotification(
    $input: CreateUserNotificationInput!
    $condition: ModelUserNotificationConditionInput
  ) {
    createUserNotification(input: $input, condition: $condition) {
      id
      type
      title
      description
      userID
      metadata
      createdBy
      updatedBy
      workspaceID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateUserNotification = /* GraphQL */ `
  mutation UpdateUserNotification(
    $input: UpdateUserNotificationInput!
    $condition: ModelUserNotificationConditionInput
  ) {
    updateUserNotification(input: $input, condition: $condition) {
      id
      type
      title
      description
      userID
      metadata
      createdBy
      updatedBy
      workspaceID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteUserNotification = /* GraphQL */ `
  mutation DeleteUserNotification(
    $input: DeleteUserNotificationInput!
    $condition: ModelUserNotificationConditionInput
  ) {
    deleteUserNotification(input: $input, condition: $condition) {
      id
      type
      title
      description
      userID
      metadata
      createdBy
      updatedBy
      workspaceID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createAlert = /* GraphQL */ `
  mutation CreateAlert(
    $input: CreateAlertInput!
    $condition: ModelAlertConditionInput
  ) {
    createAlert(input: $input, condition: $condition) {
      id
      name
      description
      triggerType
      conditions
      severity
      isActive
      cooldownMinutes
      lastTriggeredAt
      agentID
      recipients
      recipientEmails
      notifyEmail
      notifyPush
      notifyInApp
      notifyWebhook
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateAlert = /* GraphQL */ `
  mutation UpdateAlert(
    $input: UpdateAlertInput!
    $condition: ModelAlertConditionInput
  ) {
    updateAlert(input: $input, condition: $condition) {
      id
      name
      description
      triggerType
      conditions
      severity
      isActive
      cooldownMinutes
      lastTriggeredAt
      agentID
      recipients
      recipientEmails
      notifyEmail
      notifyPush
      notifyInApp
      notifyWebhook
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteAlert = /* GraphQL */ `
  mutation DeleteAlert(
    $input: DeleteAlertInput!
    $condition: ModelAlertConditionInput
  ) {
    deleteAlert(input: $input, condition: $condition) {
      id
      name
      description
      triggerType
      conditions
      severity
      isActive
      cooldownMinutes
      lastTriggeredAt
      agentID
      recipients
      recipientEmails
      notifyEmail
      notifyPush
      notifyInApp
      notifyWebhook
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createVirtualMachine = /* GraphQL */ `
  mutation CreateVirtualMachine(
    $input: CreateVirtualMachineInput!
    $condition: ModelVirtualMachineConditionInput
  ) {
    createVirtualMachine(input: $input, condition: $condition) {
      id
      name
      description
      ip
      workspaceID
      port
      metadata
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateVirtualMachine = /* GraphQL */ `
  mutation UpdateVirtualMachine(
    $input: UpdateVirtualMachineInput!
    $condition: ModelVirtualMachineConditionInput
  ) {
    updateVirtualMachine(input: $input, condition: $condition) {
      id
      name
      description
      ip
      workspaceID
      port
      metadata
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteVirtualMachine = /* GraphQL */ `
  mutation DeleteVirtualMachine(
    $input: DeleteVirtualMachineInput!
    $condition: ModelVirtualMachineConditionInput
  ) {
    deleteVirtualMachine(input: $input, condition: $condition) {
      id
      name
      description
      ip
      workspaceID
      port
      metadata
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createCustomExecutionEnvironment = /* GraphQL */ `
  mutation CreateCustomExecutionEnvironment(
    $input: CreateCustomExecutionEnvironmentInput!
    $condition: ModelCustomExecutionEnvironmentConditionInput
  ) {
    createCustomExecutionEnvironment(input: $input, condition: $condition) {
      id
      name
      description
      functionName
      availableLibraries
      ip
      workspaceID
      port
      metadata
      createdBy
      updatedBy
      isGlobal
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateCustomExecutionEnvironment = /* GraphQL */ `
  mutation UpdateCustomExecutionEnvironment(
    $input: UpdateCustomExecutionEnvironmentInput!
    $condition: ModelCustomExecutionEnvironmentConditionInput
  ) {
    updateCustomExecutionEnvironment(input: $input, condition: $condition) {
      id
      name
      description
      functionName
      availableLibraries
      ip
      workspaceID
      port
      metadata
      createdBy
      updatedBy
      isGlobal
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteCustomExecutionEnvironment = /* GraphQL */ `
  mutation DeleteCustomExecutionEnvironment(
    $input: DeleteCustomExecutionEnvironmentInput!
    $condition: ModelCustomExecutionEnvironmentConditionInput
  ) {
    deleteCustomExecutionEnvironment(input: $input, condition: $condition) {
      id
      name
      description
      functionName
      availableLibraries
      ip
      workspaceID
      port
      metadata
      createdBy
      updatedBy
      isGlobal
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createSite = /* GraphQL */ `
  mutation CreateSite(
    $input: CreateSiteInput!
    $condition: ModelSiteConditionInput
  ) {
    createSite(input: $input, condition: $condition) {
      id
      name
      description
      url
      customSitemap
      workspaceID
      topics
      status
      lastValidationDate
      lastValidationRequested
      validationToken
      allowedPaths
      siteTree
      lastScraped
      skipOwnerValidation
      useProxy
      completion_percentage
      extractImages
      freeRoaming
      scrapingCycle
      imgRetrievalPrompt
      metadata
      createdBy
      updatedBy
      scapablePages
      scrapedPagesCount
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateSite = /* GraphQL */ `
  mutation UpdateSite(
    $input: UpdateSiteInput!
    $condition: ModelSiteConditionInput
  ) {
    updateSite(input: $input, condition: $condition) {
      id
      name
      description
      url
      customSitemap
      workspaceID
      topics
      status
      lastValidationDate
      lastValidationRequested
      validationToken
      allowedPaths
      siteTree
      lastScraped
      skipOwnerValidation
      useProxy
      completion_percentage
      extractImages
      freeRoaming
      scrapingCycle
      imgRetrievalPrompt
      metadata
      createdBy
      updatedBy
      scapablePages
      scrapedPagesCount
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteSite = /* GraphQL */ `
  mutation DeleteSite(
    $input: DeleteSiteInput!
    $condition: ModelSiteConditionInput
  ) {
    deleteSite(input: $input, condition: $condition) {
      id
      name
      description
      url
      customSitemap
      workspaceID
      topics
      status
      lastValidationDate
      lastValidationRequested
      validationToken
      allowedPaths
      siteTree
      lastScraped
      skipOwnerValidation
      useProxy
      completion_percentage
      extractImages
      freeRoaming
      scrapingCycle
      imgRetrievalPrompt
      metadata
      createdBy
      updatedBy
      scapablePages
      scrapedPagesCount
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createEntityAI = /* GraphQL */ `
  mutation CreateEntityAI(
    $input: CreateEntityAIInput!
    $condition: ModelEntityAIConditionInput
  ) {
    createEntityAI(input: $input, condition: $condition) {
      id
      owner
      label
      type
      description
      emoji
      parentEntity
      backgroundColor
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateEntityAI = /* GraphQL */ `
  mutation UpdateEntityAI(
    $input: UpdateEntityAIInput!
    $condition: ModelEntityAIConditionInput
  ) {
    updateEntityAI(input: $input, condition: $condition) {
      id
      owner
      label
      type
      description
      emoji
      parentEntity
      backgroundColor
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteEntityAI = /* GraphQL */ `
  mutation DeleteEntityAI(
    $input: DeleteEntityAIInput!
    $condition: ModelEntityAIConditionInput
  ) {
    deleteEntityAI(input: $input, condition: $condition) {
      id
      owner
      label
      type
      description
      emoji
      parentEntity
      backgroundColor
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createTrainingLog = /* GraphQL */ `
  mutation CreateTrainingLog(
    $input: CreateTrainingLogInput!
    $condition: ModelTrainingLogConditionInput
  ) {
    createTrainingLog(input: $input, condition: $condition) {
      id
      owner
      name
      description
      status
      trainingIterations
      lastActivation
      duration
      trainingMeta
      trainingConfig
      workspaceID
      type
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateTrainingLog = /* GraphQL */ `
  mutation UpdateTrainingLog(
    $input: UpdateTrainingLogInput!
    $condition: ModelTrainingLogConditionInput
  ) {
    updateTrainingLog(input: $input, condition: $condition) {
      id
      owner
      name
      description
      status
      trainingIterations
      lastActivation
      duration
      trainingMeta
      trainingConfig
      workspaceID
      type
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteTrainingLog = /* GraphQL */ `
  mutation DeleteTrainingLog(
    $input: DeleteTrainingLogInput!
    $condition: ModelTrainingLogConditionInput
  ) {
    deleteTrainingLog(input: $input, condition: $condition) {
      id
      owner
      name
      description
      status
      trainingIterations
      lastActivation
      duration
      trainingMeta
      trainingConfig
      workspaceID
      type
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createBatchJobLog = /* GraphQL */ `
  mutation CreateBatchJobLog(
    $input: CreateBatchJobLogInput!
    $condition: ModelBatchJobLogConditionInput
  ) {
    createBatchJobLog(input: $input, condition: $condition) {
      id
      owner
      name
      description
      status
      duration
      batchMeta
      batchConfig
      batchOutput
      workspaceID
      type
      createdBy
      updatedBy
      benchmarkID
      agentID
      agentVersion
      reviewerAgentID
      reviewerAgentVersion
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateBatchJobLog = /* GraphQL */ `
  mutation UpdateBatchJobLog(
    $input: UpdateBatchJobLogInput!
    $condition: ModelBatchJobLogConditionInput
  ) {
    updateBatchJobLog(input: $input, condition: $condition) {
      id
      owner
      name
      description
      status
      duration
      batchMeta
      batchConfig
      batchOutput
      workspaceID
      type
      createdBy
      updatedBy
      benchmarkID
      agentID
      agentVersion
      reviewerAgentID
      reviewerAgentVersion
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteBatchJobLog = /* GraphQL */ `
  mutation DeleteBatchJobLog(
    $input: DeleteBatchJobLogInput!
    $condition: ModelBatchJobLogConditionInput
  ) {
    deleteBatchJobLog(input: $input, condition: $condition) {
      id
      owner
      name
      description
      status
      duration
      batchMeta
      batchConfig
      batchOutput
      workspaceID
      type
      createdBy
      updatedBy
      benchmarkID
      agentID
      agentVersion
      reviewerAgentID
      reviewerAgentVersion
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createAppLog = /* GraphQL */ `
  mutation CreateAppLog(
    $input: CreateAppLogInput!
    $condition: ModelAppLogConditionInput
  ) {
    createAppLog(input: $input, condition: $condition) {
      id
      owner
      type
      filename
      event
      status
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateAppLog = /* GraphQL */ `
  mutation UpdateAppLog(
    $input: UpdateAppLogInput!
    $condition: ModelAppLogConditionInput
  ) {
    updateAppLog(input: $input, condition: $condition) {
      id
      owner
      type
      filename
      event
      status
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteAppLog = /* GraphQL */ `
  mutation DeleteAppLog(
    $input: DeleteAppLogInput!
    $condition: ModelAppLogConditionInput
  ) {
    deleteAppLog(input: $input, condition: $condition) {
      id
      owner
      type
      filename
      event
      status
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createRequestLog = /* GraphQL */ `
  mutation CreateRequestLog(
    $input: CreateRequestLogInput!
    $condition: ModelRequestLogConditionInput
  ) {
    createRequestLog(input: $input, condition: $condition) {
      id
      srtKey
      type
      status
      words
      tokens
      sentences
      artifactsNumber
      modelType
      outputType
      inputTokens
      outputTokens
      totalTokens
      inputCostUSD
      outputCostUSD
      description
      totalCostUSD
      cachedInputTokens
      cacheHitRate
      cacheSavingsUSD
      callType
      callPurpose
      latencyMs
      agentID
      workspaceID
      createdBy
      updatedBy
      creationTime
      isFromToothFairy
      userID
      supportHours
      chatID
      messageID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateRequestLog = /* GraphQL */ `
  mutation UpdateRequestLog(
    $input: UpdateRequestLogInput!
    $condition: ModelRequestLogConditionInput
  ) {
    updateRequestLog(input: $input, condition: $condition) {
      id
      srtKey
      type
      status
      words
      tokens
      sentences
      artifactsNumber
      modelType
      outputType
      inputTokens
      outputTokens
      totalTokens
      inputCostUSD
      outputCostUSD
      description
      totalCostUSD
      cachedInputTokens
      cacheHitRate
      cacheSavingsUSD
      callType
      callPurpose
      latencyMs
      agentID
      workspaceID
      createdBy
      updatedBy
      creationTime
      isFromToothFairy
      userID
      supportHours
      chatID
      messageID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteRequestLog = /* GraphQL */ `
  mutation DeleteRequestLog(
    $input: DeleteRequestLogInput!
    $condition: ModelRequestLogConditionInput
  ) {
    deleteRequestLog(input: $input, condition: $condition) {
      id
      srtKey
      type
      status
      words
      tokens
      sentences
      artifactsNumber
      modelType
      outputType
      inputTokens
      outputTokens
      totalTokens
      inputCostUSD
      outputCostUSD
      description
      totalCostUSD
      cachedInputTokens
      cacheHitRate
      cacheSavingsUSD
      callType
      callPurpose
      latencyMs
      agentID
      workspaceID
      createdBy
      updatedBy
      creationTime
      isFromToothFairy
      userID
      supportHours
      chatID
      messageID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createOutputStream = /* GraphQL */ `
  mutation CreateOutputStream(
    $input: CreateOutputStreamInput!
    $condition: ModelOutputStreamConditionInput
  ) {
    createOutputStream(input: $input, condition: $condition) {
      id
      content
      t_content
      prompt
      t_prompt
      workspaceID
      type
      status
      humanFeedback
      humanFeedbackComment
      humanFeedbackType
      humanFeedbackSubType
      humanFeedbackProvidedBy
      adminResolution
      adminChecked
      autoTune
      scoring
      metadata
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateOutputStream = /* GraphQL */ `
  mutation UpdateOutputStream(
    $input: UpdateOutputStreamInput!
    $condition: ModelOutputStreamConditionInput
  ) {
    updateOutputStream(input: $input, condition: $condition) {
      id
      content
      t_content
      prompt
      t_prompt
      workspaceID
      type
      status
      humanFeedback
      humanFeedbackComment
      humanFeedbackType
      humanFeedbackSubType
      humanFeedbackProvidedBy
      adminResolution
      adminChecked
      autoTune
      scoring
      metadata
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteOutputStream = /* GraphQL */ `
  mutation DeleteOutputStream(
    $input: DeleteOutputStreamInput!
    $condition: ModelOutputStreamConditionInput
  ) {
    deleteOutputStream(input: $input, condition: $condition) {
      id
      content
      t_content
      prompt
      t_prompt
      workspaceID
      type
      status
      humanFeedback
      humanFeedbackComment
      humanFeedbackType
      humanFeedbackSubType
      humanFeedbackProvidedBy
      adminResolution
      adminChecked
      autoTune
      scoring
      metadata
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createFolders = /* GraphQL */ `
  mutation CreateFolders(
    $input: CreateFoldersInput!
    $condition: ModelFoldersConditionInput
  ) {
    createFolders(input: $input, condition: $condition) {
      id
      owner
      name
      description
      emoji
      status
      allowedTopics
      parent
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateFolders = /* GraphQL */ `
  mutation UpdateFolders(
    $input: UpdateFoldersInput!
    $condition: ModelFoldersConditionInput
  ) {
    updateFolders(input: $input, condition: $condition) {
      id
      owner
      name
      description
      emoji
      status
      allowedTopics
      parent
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteFolders = /* GraphQL */ `
  mutation DeleteFolders(
    $input: DeleteFoldersInput!
    $condition: ModelFoldersConditionInput
  ) {
    deleteFolders(input: $input, condition: $condition) {
      id
      owner
      name
      description
      emoji
      status
      allowedTopics
      parent
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createDictionaryItem = /* GraphQL */ `
  mutation CreateDictionaryItem(
    $input: CreateDictionaryItemInput!
    $condition: ModelDictionaryItemConditionInput
  ) {
    createDictionaryItem(input: $input, condition: $condition) {
      id
      owner
      sourceLanguage
      targetLanguage
      sourceText
      targetText
      workspaceID
      pos
      description
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateDictionaryItem = /* GraphQL */ `
  mutation UpdateDictionaryItem(
    $input: UpdateDictionaryItemInput!
    $condition: ModelDictionaryItemConditionInput
  ) {
    updateDictionaryItem(input: $input, condition: $condition) {
      id
      owner
      sourceLanguage
      targetLanguage
      sourceText
      targetText
      workspaceID
      pos
      description
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteDictionaryItem = /* GraphQL */ `
  mutation DeleteDictionaryItem(
    $input: DeleteDictionaryItemInput!
    $condition: ModelDictionaryItemConditionInput
  ) {
    deleteDictionaryItem(input: $input, condition: $condition) {
      id
      owner
      sourceLanguage
      targetLanguage
      sourceText
      targetText
      workspaceID
      pos
      description
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createChat = /* GraphQL */ `
  mutation CreateChat(
    $input: CreateChatInput!
    $condition: ModelChatConditionInput
  ) {
    createChat(input: $input, condition: $condition) {
      id
      owner
      name
      description
      status {
        status
        lastUpdated
      }
      workspaceID
      creationTime
      createdBy
      updatedBy
      visibility
      isAIReplying
      activeMessageForAI
      messages {
        items {
          id
          role
          chatID
          text
          t_text
          t_text_summary
          createdAt
          creationTime
          updatedAt
          scoring
          embeddingId
          humanFeedback
          humanFeedbackComment
          humanFeedbackType
          humanFeedbackSubType
          humanFeedbackProvidedBy
          adminResolution
          prevMessage
          prevMessagePosEq
          prevMessageNegEq
          correctContext
          correctAnswer
          adminChecked
          autoTune
          userID
          agentID
          humanFeedbackForInstruction
          images
          audios
          videos
          files
          imagesText
          audiosText
          videosText
          filesText
          isAI
          messageType
          status
          metadata
          callbackMetadata
          workspaceID
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      chatHistory
      topics
      documentId
      primaryRole
      primaryAgent
      plannerAgent
      forcePlannerStop
      allowMultipleRoles
      handedOffToHuman
      roles
      language
      summary
      caseId
      customerId
      caseInfo
      customerInfo
      projectId
      projectInfo
      genericEntityId
      genericEntityInfo
      metadata
      userFeedbackOnSteps
      channelSettings
      sourceJobID
      canvasID
      canvasOperations
      canvasLastChangesetID
      canvasLastChangesetTimestamp
      externalParticipantId
      piiDetected
      piiTypes
      piiOccurrences
      toxicityDetected
      toxicityScore
      toxicityCategories
      customerSatisfactionScore
      customerSatisfactionFeedback
      requestCompleted
      requestCompletionScore
      escalationRequired
      escalationReason
      qualityScore
      qualityNotes
      customAnalytics
      planMode
      planFile
      askBeforeExec
      planStatus
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateChat = /* GraphQL */ `
  mutation UpdateChat(
    $input: UpdateChatInput!
    $condition: ModelChatConditionInput
  ) {
    updateChat(input: $input, condition: $condition) {
      id
      owner
      name
      description
      status {
        status
        lastUpdated
      }
      workspaceID
      creationTime
      createdBy
      updatedBy
      visibility
      isAIReplying
      activeMessageForAI
      messages {
        items {
          id
          role
          chatID
          text
          t_text
          t_text_summary
          createdAt
          creationTime
          updatedAt
          scoring
          embeddingId
          humanFeedback
          humanFeedbackComment
          humanFeedbackType
          humanFeedbackSubType
          humanFeedbackProvidedBy
          adminResolution
          prevMessage
          prevMessagePosEq
          prevMessageNegEq
          correctContext
          correctAnswer
          adminChecked
          autoTune
          userID
          agentID
          humanFeedbackForInstruction
          images
          audios
          videos
          files
          imagesText
          audiosText
          videosText
          filesText
          isAI
          messageType
          status
          metadata
          callbackMetadata
          workspaceID
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      chatHistory
      topics
      documentId
      primaryRole
      primaryAgent
      plannerAgent
      forcePlannerStop
      allowMultipleRoles
      handedOffToHuman
      roles
      language
      summary
      caseId
      customerId
      caseInfo
      customerInfo
      projectId
      projectInfo
      genericEntityId
      genericEntityInfo
      metadata
      userFeedbackOnSteps
      channelSettings
      sourceJobID
      canvasID
      canvasOperations
      canvasLastChangesetID
      canvasLastChangesetTimestamp
      externalParticipantId
      piiDetected
      piiTypes
      piiOccurrences
      toxicityDetected
      toxicityScore
      toxicityCategories
      customerSatisfactionScore
      customerSatisfactionFeedback
      requestCompleted
      requestCompletionScore
      escalationRequired
      escalationReason
      qualityScore
      qualityNotes
      customAnalytics
      planMode
      planFile
      askBeforeExec
      planStatus
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteChat = /* GraphQL */ `
  mutation DeleteChat(
    $input: DeleteChatInput!
    $condition: ModelChatConditionInput
  ) {
    deleteChat(input: $input, condition: $condition) {
      id
      owner
      name
      description
      status {
        status
        lastUpdated
      }
      workspaceID
      creationTime
      createdBy
      updatedBy
      visibility
      isAIReplying
      activeMessageForAI
      messages {
        items {
          id
          role
          chatID
          text
          t_text
          t_text_summary
          createdAt
          creationTime
          updatedAt
          scoring
          embeddingId
          humanFeedback
          humanFeedbackComment
          humanFeedbackType
          humanFeedbackSubType
          humanFeedbackProvidedBy
          adminResolution
          prevMessage
          prevMessagePosEq
          prevMessageNegEq
          correctContext
          correctAnswer
          adminChecked
          autoTune
          userID
          agentID
          humanFeedbackForInstruction
          images
          audios
          videos
          files
          imagesText
          audiosText
          videosText
          filesText
          isAI
          messageType
          status
          metadata
          callbackMetadata
          workspaceID
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      chatHistory
      topics
      documentId
      primaryRole
      primaryAgent
      plannerAgent
      forcePlannerStop
      allowMultipleRoles
      handedOffToHuman
      roles
      language
      summary
      caseId
      customerId
      caseInfo
      customerInfo
      projectId
      projectInfo
      genericEntityId
      genericEntityInfo
      metadata
      userFeedbackOnSteps
      channelSettings
      sourceJobID
      canvasID
      canvasOperations
      canvasLastChangesetID
      canvasLastChangesetTimestamp
      externalParticipantId
      piiDetected
      piiTypes
      piiOccurrences
      toxicityDetected
      toxicityScore
      toxicityCategories
      customerSatisfactionScore
      customerSatisfactionFeedback
      requestCompleted
      requestCompletionScore
      escalationRequired
      escalationReason
      qualityScore
      qualityNotes
      customAnalytics
      planMode
      planFile
      askBeforeExec
      planStatus
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createCustomPrompt = /* GraphQL */ `
  mutation CreateCustomPrompt(
    $input: CreateCustomPromptInput!
    $condition: ModelCustomPromptConditionInput
  ) {
    createCustomPrompt(input: $input, condition: $condition) {
      id
      type
      scope
      style
      domain
      label
      promptLength
      promptPlaceholder
      interpolationString
      availableToAgents
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateCustomPrompt = /* GraphQL */ `
  mutation UpdateCustomPrompt(
    $input: UpdateCustomPromptInput!
    $condition: ModelCustomPromptConditionInput
  ) {
    updateCustomPrompt(input: $input, condition: $condition) {
      id
      type
      scope
      style
      domain
      label
      promptLength
      promptPlaceholder
      interpolationString
      availableToAgents
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteCustomPrompt = /* GraphQL */ `
  mutation DeleteCustomPrompt(
    $input: DeleteCustomPromptInput!
    $condition: ModelCustomPromptConditionInput
  ) {
    deleteCustomPrompt(input: $input, condition: $condition) {
      id
      type
      scope
      style
      domain
      label
      promptLength
      promptPlaceholder
      interpolationString
      availableToAgents
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createCronJob = /* GraphQL */ `
  mutation CreateCronJob(
    $input: CreateCronJobInput!
    $condition: ModelCronJobConditionInput
  ) {
    createCronJob(input: $input, condition: $condition) {
      id
      name
      description
      forcedPrompt
      type
      routineConfig {
        maxPlannedActions
      }
      agentID
      customPromptID
      workspaceID
      schedule {
        frequency
        interval
        cronExpression
        dayOfWeek
        dayOfMonth
        hour
        minute
        startDate
        endDate
      }
      timezone
      isActive
      lastRunAt
      nextRunAt
      status
      executionConfig {
        timeout
        maxDuration
        priority
        inputParameters
        outputFormat
        webhookUrl
        webhookHeaders
      }
      notificationConfig {
        onSuccess
        onFailure
        onStart
        emailRecipients
        communicationServiceID
      }
      retryConfig {
        maxRetries
        retryInterval
        backoffMultiplier
        maxRetryInterval
      }
      metadata
      startDate
      endDate
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateCronJob = /* GraphQL */ `
  mutation UpdateCronJob(
    $input: UpdateCronJobInput!
    $condition: ModelCronJobConditionInput
  ) {
    updateCronJob(input: $input, condition: $condition) {
      id
      name
      description
      forcedPrompt
      type
      routineConfig {
        maxPlannedActions
      }
      agentID
      customPromptID
      workspaceID
      schedule {
        frequency
        interval
        cronExpression
        dayOfWeek
        dayOfMonth
        hour
        minute
        startDate
        endDate
      }
      timezone
      isActive
      lastRunAt
      nextRunAt
      status
      executionConfig {
        timeout
        maxDuration
        priority
        inputParameters
        outputFormat
        webhookUrl
        webhookHeaders
      }
      notificationConfig {
        onSuccess
        onFailure
        onStart
        emailRecipients
        communicationServiceID
      }
      retryConfig {
        maxRetries
        retryInterval
        backoffMultiplier
        maxRetryInterval
      }
      metadata
      startDate
      endDate
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteCronJob = /* GraphQL */ `
  mutation DeleteCronJob(
    $input: DeleteCronJobInput!
    $condition: ModelCronJobConditionInput
  ) {
    deleteCronJob(input: $input, condition: $condition) {
      id
      name
      description
      forcedPrompt
      type
      routineConfig {
        maxPlannedActions
      }
      agentID
      customPromptID
      workspaceID
      schedule {
        frequency
        interval
        cronExpression
        dayOfWeek
        dayOfMonth
        hour
        minute
        startDate
        endDate
      }
      timezone
      isActive
      lastRunAt
      nextRunAt
      status
      executionConfig {
        timeout
        maxDuration
        priority
        inputParameters
        outputFormat
        webhookUrl
        webhookHeaders
      }
      notificationConfig {
        onSuccess
        onFailure
        onStart
        emailRecipients
        communicationServiceID
      }
      retryConfig {
        maxRetries
        retryInterval
        backoffMultiplier
        maxRetryInterval
      }
      metadata
      startDate
      endDate
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createTrigger = /* GraphQL */ `
  mutation CreateTrigger(
    $input: CreateTriggerInput!
    $condition: ModelTriggerConditionInput
  ) {
    createTrigger(input: $input, condition: $condition) {
      id
      name
      description
      agentID
      customPromptID
      forcedPrompt
      eventSourceType
      eventConfig
      isActive
      status
      lastTriggeredAt
      lastEventID
      triggerCount
      executionConfig {
        timeout
        maxDuration
        priority
        inputParameters
        outputFormat
        webhookUrl
        webhookHeaders
      }
      notificationConfig {
        onSuccess
        onFailure
        onStart
        emailRecipients
        communicationServiceID
      }
      retryConfig {
        maxRetries
        retryInterval
        backoffMultiplier
        maxRetryInterval
      }
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      metadata
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateTrigger = /* GraphQL */ `
  mutation UpdateTrigger(
    $input: UpdateTriggerInput!
    $condition: ModelTriggerConditionInput
  ) {
    updateTrigger(input: $input, condition: $condition) {
      id
      name
      description
      agentID
      customPromptID
      forcedPrompt
      eventSourceType
      eventConfig
      isActive
      status
      lastTriggeredAt
      lastEventID
      triggerCount
      executionConfig {
        timeout
        maxDuration
        priority
        inputParameters
        outputFormat
        webhookUrl
        webhookHeaders
      }
      notificationConfig {
        onSuccess
        onFailure
        onStart
        emailRecipients
        communicationServiceID
      }
      retryConfig {
        maxRetries
        retryInterval
        backoffMultiplier
        maxRetryInterval
      }
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      metadata
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteTrigger = /* GraphQL */ `
  mutation DeleteTrigger(
    $input: DeleteTriggerInput!
    $condition: ModelTriggerConditionInput
  ) {
    deleteTrigger(input: $input, condition: $condition) {
      id
      name
      description
      agentID
      customPromptID
      forcedPrompt
      eventSourceType
      eventConfig
      isActive
      status
      lastTriggeredAt
      lastEventID
      triggerCount
      executionConfig {
        timeout
        maxDuration
        priority
        inputParameters
        outputFormat
        webhookUrl
        webhookHeaders
      }
      notificationConfig {
        onSuccess
        onFailure
        onStart
        emailRecipients
        communicationServiceID
      }
      retryConfig {
        maxRetries
        retryInterval
        backoffMultiplier
        maxRetryInterval
      }
      workspaceID
      createdBy
      updatedBy
      createdAt
      updatedAt
      metadata
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createCustomCodeExecutionEnvironment = /* GraphQL */ `
  mutation CreateCustomCodeExecutionEnvironment(
    $input: CreateCustomCodeExecutionEnvironmentInput!
    $condition: ModelCustomCodeExecutionEnvironmentConditionInput
  ) {
    createCustomCodeExecutionEnvironment(input: $input, condition: $condition) {
      id
      name
      description
      functionName
      availableLibraries
      customExecutionInstructions
      customExecutionCode
      customExecutionSecrets
      staticDocs
      staticArtifacts
      allowExternalAPI
      hardcodedScript
      isTemplate
      workspaceID
      createdBy
      updatedBy
      customCodeExecutionEnvironmentVersion
      customCodeExecutionEnvironmentType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateCustomCodeExecutionEnvironment = /* GraphQL */ `
  mutation UpdateCustomCodeExecutionEnvironment(
    $input: UpdateCustomCodeExecutionEnvironmentInput!
    $condition: ModelCustomCodeExecutionEnvironmentConditionInput
  ) {
    updateCustomCodeExecutionEnvironment(input: $input, condition: $condition) {
      id
      name
      description
      functionName
      availableLibraries
      customExecutionInstructions
      customExecutionCode
      customExecutionSecrets
      staticDocs
      staticArtifacts
      allowExternalAPI
      hardcodedScript
      isTemplate
      workspaceID
      createdBy
      updatedBy
      customCodeExecutionEnvironmentVersion
      customCodeExecutionEnvironmentType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteCustomCodeExecutionEnvironment = /* GraphQL */ `
  mutation DeleteCustomCodeExecutionEnvironment(
    $input: DeleteCustomCodeExecutionEnvironmentInput!
    $condition: ModelCustomCodeExecutionEnvironmentConditionInput
  ) {
    deleteCustomCodeExecutionEnvironment(input: $input, condition: $condition) {
      id
      name
      description
      functionName
      availableLibraries
      customExecutionInstructions
      customExecutionCode
      customExecutionSecrets
      staticDocs
      staticArtifacts
      allowExternalAPI
      hardcodedScript
      isTemplate
      workspaceID
      createdBy
      updatedBy
      customCodeExecutionEnvironmentVersion
      customCodeExecutionEnvironmentType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createChatMessage = /* GraphQL */ `
  mutation CreateChatMessage(
    $input: CreateChatMessageInput!
    $condition: ModelChatMessageConditionInput
  ) {
    createChatMessage(input: $input, condition: $condition) {
      id
      role
      chatID
      text
      t_text
      t_text_summary
      createdAt
      creationTime
      updatedAt
      scoring
      embeddingId
      humanFeedback
      humanFeedbackComment
      humanFeedbackType
      humanFeedbackSubType
      humanFeedbackProvidedBy
      adminResolution
      prevMessage
      prevMessagePosEq
      prevMessageNegEq
      correctContext
      correctAnswer
      adminChecked
      autoTune
      userID
      agentID
      humanFeedbackForInstruction
      images
      audios
      videos
      files
      imagesText
      audiosText
      videosText
      filesText
      isAI
      messageType
      status
      metadata
      callbackMetadata
      workspaceID
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateChatMessage = /* GraphQL */ `
  mutation UpdateChatMessage(
    $input: UpdateChatMessageInput!
    $condition: ModelChatMessageConditionInput
  ) {
    updateChatMessage(input: $input, condition: $condition) {
      id
      role
      chatID
      text
      t_text
      t_text_summary
      createdAt
      creationTime
      updatedAt
      scoring
      embeddingId
      humanFeedback
      humanFeedbackComment
      humanFeedbackType
      humanFeedbackSubType
      humanFeedbackProvidedBy
      adminResolution
      prevMessage
      prevMessagePosEq
      prevMessageNegEq
      correctContext
      correctAnswer
      adminChecked
      autoTune
      userID
      agentID
      humanFeedbackForInstruction
      images
      audios
      videos
      files
      imagesText
      audiosText
      videosText
      filesText
      isAI
      messageType
      status
      metadata
      callbackMetadata
      workspaceID
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteChatMessage = /* GraphQL */ `
  mutation DeleteChatMessage(
    $input: DeleteChatMessageInput!
    $condition: ModelChatMessageConditionInput
  ) {
    deleteChatMessage(input: $input, condition: $condition) {
      id
      role
      chatID
      text
      t_text
      t_text_summary
      createdAt
      creationTime
      updatedAt
      scoring
      embeddingId
      humanFeedback
      humanFeedbackComment
      humanFeedbackType
      humanFeedbackSubType
      humanFeedbackProvidedBy
      adminResolution
      prevMessage
      prevMessagePosEq
      prevMessageNegEq
      correctContext
      correctAnswer
      adminChecked
      autoTune
      userID
      agentID
      humanFeedbackForInstruction
      images
      audios
      videos
      files
      imagesText
      audiosText
      videosText
      filesText
      isAI
      messageType
      status
      metadata
      callbackMetadata
      workspaceID
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createCommunicationService = /* GraphQL */ `
  mutation CreateCommunicationService(
    $input: CreateCommunicationServiceInput!
    $condition: ModelCommunicationServiceConditionInput
  ) {
    createCommunicationService(input: $input, condition: $condition) {
      id
      workspaceID
      name
      description
      channel
      provider
      senderid
      fromNumber
      tokenSecret
      sipTrunkId
      isActive
      config
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateCommunicationService = /* GraphQL */ `
  mutation UpdateCommunicationService(
    $input: UpdateCommunicationServiceInput!
    $condition: ModelCommunicationServiceConditionInput
  ) {
    updateCommunicationService(input: $input, condition: $condition) {
      id
      workspaceID
      name
      description
      channel
      provider
      senderid
      fromNumber
      tokenSecret
      sipTrunkId
      isActive
      config
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteCommunicationService = /* GraphQL */ `
  mutation DeleteCommunicationService(
    $input: DeleteCommunicationServiceInput!
    $condition: ModelCommunicationServiceConditionInput
  ) {
    deleteCommunicationService(input: $input, condition: $condition) {
      id
      workspaceID
      name
      description
      channel
      provider
      senderid
      fromNumber
      tokenSecret
      sipTrunkId
      isActive
      config
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createSubscriptionPricingPlan = /* GraphQL */ `
  mutation CreateSubscriptionPricingPlan(
    $input: CreateSubscriptionPricingPlanInput!
    $condition: ModelSubscriptionPricingPlanConditionInput
  ) {
    createSubscriptionPricingPlan(input: $input, condition: $condition) {
      id
      type
      subscriptionStatus
      isPredictionOnDemandGlobal
      isTrainingOnDemandGlobal
      predictionRequestsGlobal
      batchRequestsGlobal
      trainingMinutesGlobal
      baseModelGN
      baseModelQA
      baseModelNLP
      maxUsers
      maxPowerUsers
      agcEnabled
      isDownloadModelEnabled
      isDownloadDataEnabled
      isAPIAccessEnabled
      isBatchJobsEnabled
      isSentimentReviewerEnabled
      isBusinessAnalystEnabled
      isContentCreatorEnabled
      isPriorityTrainingEnabled
      isPredictionGPUAccelerationEnabledGlobal
      isPredictionGPUAccelerationEnabledRC
      isPredictionGPUAccelerationEnabledNLP
      aiMaxConsumption {
        generator {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        questioner {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        translator {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        answerer {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        parser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tokenizer {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        embedder {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        detector {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        chatter {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        planner {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        analyser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        code_execution {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        browser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        voice {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tfcode {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tfdesign {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        proxy {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        vectorisation {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        image_extraction {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        support {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        lastUpdate
        requestsLast30Minutes
        requestsLast24Hours
        totalUoI
        totalCostUSD
        familyBudgetUoI
        familyMaxUsers
        childrenCount
        cachedInputTokens
        cacheSavingsUSD
      }
      maxMrcDocs
      maxAgents
      maxSites
      maxBenchmarks
      predictionRequestsAPI
      accuracyModelEnabled
      isTrainingNLPEnabled
      isTrainingQAEnabled
      isTrainingGNEnabled
      isLongTermMemoryEnabled
      isFunctionsEnabled
      isDBFunctionsEnabled
      isHtmlFunctionsEnabled
      isSitesBindingEnabled
      isAgentsSecurityEnabled
      isWidgetChatsHistoryEnabled
      maxRequests30Minutes
      maxRequests24Hours
      defaultSupportHours
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateSubscriptionPricingPlan = /* GraphQL */ `
  mutation UpdateSubscriptionPricingPlan(
    $input: UpdateSubscriptionPricingPlanInput!
    $condition: ModelSubscriptionPricingPlanConditionInput
  ) {
    updateSubscriptionPricingPlan(input: $input, condition: $condition) {
      id
      type
      subscriptionStatus
      isPredictionOnDemandGlobal
      isTrainingOnDemandGlobal
      predictionRequestsGlobal
      batchRequestsGlobal
      trainingMinutesGlobal
      baseModelGN
      baseModelQA
      baseModelNLP
      maxUsers
      maxPowerUsers
      agcEnabled
      isDownloadModelEnabled
      isDownloadDataEnabled
      isAPIAccessEnabled
      isBatchJobsEnabled
      isSentimentReviewerEnabled
      isBusinessAnalystEnabled
      isContentCreatorEnabled
      isPriorityTrainingEnabled
      isPredictionGPUAccelerationEnabledGlobal
      isPredictionGPUAccelerationEnabledRC
      isPredictionGPUAccelerationEnabledNLP
      aiMaxConsumption {
        generator {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        questioner {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        translator {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        answerer {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        parser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tokenizer {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        embedder {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        detector {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        chatter {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        planner {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        analyser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        code_execution {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        browser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        voice {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tfcode {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tfdesign {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        proxy {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        vectorisation {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        image_extraction {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        support {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        lastUpdate
        requestsLast30Minutes
        requestsLast24Hours
        totalUoI
        totalCostUSD
        familyBudgetUoI
        familyMaxUsers
        childrenCount
        cachedInputTokens
        cacheSavingsUSD
      }
      maxMrcDocs
      maxAgents
      maxSites
      maxBenchmarks
      predictionRequestsAPI
      accuracyModelEnabled
      isTrainingNLPEnabled
      isTrainingQAEnabled
      isTrainingGNEnabled
      isLongTermMemoryEnabled
      isFunctionsEnabled
      isDBFunctionsEnabled
      isHtmlFunctionsEnabled
      isSitesBindingEnabled
      isAgentsSecurityEnabled
      isWidgetChatsHistoryEnabled
      maxRequests30Minutes
      maxRequests24Hours
      defaultSupportHours
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteSubscriptionPricingPlan = /* GraphQL */ `
  mutation DeleteSubscriptionPricingPlan(
    $input: DeleteSubscriptionPricingPlanInput!
    $condition: ModelSubscriptionPricingPlanConditionInput
  ) {
    deleteSubscriptionPricingPlan(input: $input, condition: $condition) {
      id
      type
      subscriptionStatus
      isPredictionOnDemandGlobal
      isTrainingOnDemandGlobal
      predictionRequestsGlobal
      batchRequestsGlobal
      trainingMinutesGlobal
      baseModelGN
      baseModelQA
      baseModelNLP
      maxUsers
      maxPowerUsers
      agcEnabled
      isDownloadModelEnabled
      isDownloadDataEnabled
      isAPIAccessEnabled
      isBatchJobsEnabled
      isSentimentReviewerEnabled
      isBusinessAnalystEnabled
      isContentCreatorEnabled
      isPriorityTrainingEnabled
      isPredictionGPUAccelerationEnabledGlobal
      isPredictionGPUAccelerationEnabledRC
      isPredictionGPUAccelerationEnabledNLP
      aiMaxConsumption {
        generator {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        questioner {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        translator {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        answerer {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        parser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tokenizer {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        embedder {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        detector {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        chatter {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        planner {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        analyser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        code_execution {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        browser {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        voice {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tfcode {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        tfdesign {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        proxy {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        vectorisation {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        image_extraction {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        support {
          requests
          words
          tokens
          sentences
          apiRequests
          uoi
          costUSD
          inputTokens
          cachedInputTokens
          cacheSavingsUSD
        }
        lastUpdate
        requestsLast30Minutes
        requestsLast24Hours
        totalUoI
        totalCostUSD
        familyBudgetUoI
        familyMaxUsers
        childrenCount
        cachedInputTokens
        cacheSavingsUSD
      }
      maxMrcDocs
      maxAgents
      maxSites
      maxBenchmarks
      predictionRequestsAPI
      accuracyModelEnabled
      isTrainingNLPEnabled
      isTrainingQAEnabled
      isTrainingGNEnabled
      isLongTermMemoryEnabled
      isFunctionsEnabled
      isDBFunctionsEnabled
      isHtmlFunctionsEnabled
      isSitesBindingEnabled
      isAgentsSecurityEnabled
      isWidgetChatsHistoryEnabled
      maxRequests30Minutes
      maxRequests24Hours
      defaultSupportHours
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createVoucher = /* GraphQL */ `
  mutation CreateVoucher(
    $input: CreateVoucherInput!
    $condition: ModelVoucherConditionInput
  ) {
    createVoucher(input: $input, condition: $condition) {
      id
      name
      description
      code
      amount
      currency
      startDate
      endDate
      status
      type
      metadata
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateVoucher = /* GraphQL */ `
  mutation UpdateVoucher(
    $input: UpdateVoucherInput!
    $condition: ModelVoucherConditionInput
  ) {
    updateVoucher(input: $input, condition: $condition) {
      id
      name
      description
      code
      amount
      currency
      startDate
      endDate
      status
      type
      metadata
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteVoucher = /* GraphQL */ `
  mutation DeleteVoucher(
    $input: DeleteVoucherInput!
    $condition: ModelVoucherConditionInput
  ) {
    deleteVoucher(input: $input, condition: $condition) {
      id
      name
      description
      code
      amount
      currency
      startDate
      endDate
      status
      type
      metadata
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createVoucherRedemption = /* GraphQL */ `
  mutation CreateVoucherRedemption(
    $input: CreateVoucherRedemptionInput!
    $condition: ModelVoucherRedemptionConditionInput
  ) {
    createVoucherRedemption(input: $input, condition: $condition) {
      id
      voucherID
      userID
      workspaceID
      redeemedAt
      appliedAmount
      appliedCurrency
      orderID
      metadata
      createdBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateVoucherRedemption = /* GraphQL */ `
  mutation UpdateVoucherRedemption(
    $input: UpdateVoucherRedemptionInput!
    $condition: ModelVoucherRedemptionConditionInput
  ) {
    updateVoucherRedemption(input: $input, condition: $condition) {
      id
      voucherID
      userID
      workspaceID
      redeemedAt
      appliedAmount
      appliedCurrency
      orderID
      metadata
      createdBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteVoucherRedemption = /* GraphQL */ `
  mutation DeleteVoucherRedemption(
    $input: DeleteVoucherRedemptionInput!
    $condition: ModelVoucherRedemptionConditionInput
  ) {
    deleteVoucherRedemption(input: $input, condition: $condition) {
      id
      voucherID
      userID
      workspaceID
      redeemedAt
      appliedAmount
      appliedCurrency
      orderID
      metadata
      createdBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createSubscriptionBaseConfig = /* GraphQL */ `
  mutation CreateSubscriptionBaseConfig(
    $input: CreateSubscriptionBaseConfigInput!
    $condition: ModelSubscriptionBaseConfigConditionInput
  ) {
    createSubscriptionBaseConfig(input: $input, condition: $condition) {
      id
      type
      planConfig {
        domain
        parsingConfig {
          questionsLimit
          answerAsNER
          answerByParagraph
          uniqueAnswer
          isSentenceSplitEnabled
          isImplicitSelfEnabled
          temperature
          maxTokens
          topP
          topK
          qaDocTopK
          frequencyPenalty
          presencePenalty
          qaTopP
          qaTopK
          qaMaxTokens
          qaTemperature
          qaFrequencyPenalty
          qaPresencePenalty
          qaReplyOutsidePassage
          qaAiKnowledge
          qaInhibitionPassage
          qaEnhancementPassage
          qaRole
          qaDefaultAnswer
          qaStopSequence
          stopSequence
          stopPrompt
          qaBlender
          agcEnabled
        }
        notificationConfig {
          emailsList
          emailOnTrainingCompleted
          emailOnBatchCompleted
          emailOnBatchFailed
          emailOnBatchStart
          emailOnTrainingFailed
          emailOnTrainingStart
          notifyAllUsersInWorkspace
          notifyOnThreasholdConsumption
          notificationThresholdConsumption
        }
        trainingConfig {
          trainingIterations
          trainingIterationsNLP
          trainingIterationsRC
          trainingEpochsNLP
          trainingEpochsRC
          trainingEpochsGN
          maxStepsNLP
          patienceNLP
          learningRateNLP
          learningRateRC
          testSizeNLP
          testSizeRC
          batchSizeNLP
          batchSizeRC
          datasetTestSizeThresholdNLP
          datasetTestSizeThresholdRC
          learningRateGN
          testSizeGN
          batchSizeGN
          datasetTestSizeThresholdGN
          enableManagedSpotTraining
          maxRuntimeWaitTime
          maxRuntime
          includeReadComprehensionDataInTraining
          generateDockerImageForRCengine
          generateDockerImageForNLPengine
          generateDockerImageForGNengine
          emailsListForTrainingConfirmation
          maxQueueWaitTime
        }
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateSubscriptionBaseConfig = /* GraphQL */ `
  mutation UpdateSubscriptionBaseConfig(
    $input: UpdateSubscriptionBaseConfigInput!
    $condition: ModelSubscriptionBaseConfigConditionInput
  ) {
    updateSubscriptionBaseConfig(input: $input, condition: $condition) {
      id
      type
      planConfig {
        domain
        parsingConfig {
          questionsLimit
          answerAsNER
          answerByParagraph
          uniqueAnswer
          isSentenceSplitEnabled
          isImplicitSelfEnabled
          temperature
          maxTokens
          topP
          topK
          qaDocTopK
          frequencyPenalty
          presencePenalty
          qaTopP
          qaTopK
          qaMaxTokens
          qaTemperature
          qaFrequencyPenalty
          qaPresencePenalty
          qaReplyOutsidePassage
          qaAiKnowledge
          qaInhibitionPassage
          qaEnhancementPassage
          qaRole
          qaDefaultAnswer
          qaStopSequence
          stopSequence
          stopPrompt
          qaBlender
          agcEnabled
        }
        notificationConfig {
          emailsList
          emailOnTrainingCompleted
          emailOnBatchCompleted
          emailOnBatchFailed
          emailOnBatchStart
          emailOnTrainingFailed
          emailOnTrainingStart
          notifyAllUsersInWorkspace
          notifyOnThreasholdConsumption
          notificationThresholdConsumption
        }
        trainingConfig {
          trainingIterations
          trainingIterationsNLP
          trainingIterationsRC
          trainingEpochsNLP
          trainingEpochsRC
          trainingEpochsGN
          maxStepsNLP
          patienceNLP
          learningRateNLP
          learningRateRC
          testSizeNLP
          testSizeRC
          batchSizeNLP
          batchSizeRC
          datasetTestSizeThresholdNLP
          datasetTestSizeThresholdRC
          learningRateGN
          testSizeGN
          batchSizeGN
          datasetTestSizeThresholdGN
          enableManagedSpotTraining
          maxRuntimeWaitTime
          maxRuntime
          includeReadComprehensionDataInTraining
          generateDockerImageForRCengine
          generateDockerImageForNLPengine
          generateDockerImageForGNengine
          emailsListForTrainingConfirmation
          maxQueueWaitTime
        }
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteSubscriptionBaseConfig = /* GraphQL */ `
  mutation DeleteSubscriptionBaseConfig(
    $input: DeleteSubscriptionBaseConfigInput!
    $condition: ModelSubscriptionBaseConfigConditionInput
  ) {
    deleteSubscriptionBaseConfig(input: $input, condition: $condition) {
      id
      type
      planConfig {
        domain
        parsingConfig {
          questionsLimit
          answerAsNER
          answerByParagraph
          uniqueAnswer
          isSentenceSplitEnabled
          isImplicitSelfEnabled
          temperature
          maxTokens
          topP
          topK
          qaDocTopK
          frequencyPenalty
          presencePenalty
          qaTopP
          qaTopK
          qaMaxTokens
          qaTemperature
          qaFrequencyPenalty
          qaPresencePenalty
          qaReplyOutsidePassage
          qaAiKnowledge
          qaInhibitionPassage
          qaEnhancementPassage
          qaRole
          qaDefaultAnswer
          qaStopSequence
          stopSequence
          stopPrompt
          qaBlender
          agcEnabled
        }
        notificationConfig {
          emailsList
          emailOnTrainingCompleted
          emailOnBatchCompleted
          emailOnBatchFailed
          emailOnBatchStart
          emailOnTrainingFailed
          emailOnTrainingStart
          notifyAllUsersInWorkspace
          notifyOnThreasholdConsumption
          notificationThresholdConsumption
        }
        trainingConfig {
          trainingIterations
          trainingIterationsNLP
          trainingIterationsRC
          trainingEpochsNLP
          trainingEpochsRC
          trainingEpochsGN
          maxStepsNLP
          patienceNLP
          learningRateNLP
          learningRateRC
          testSizeNLP
          testSizeRC
          batchSizeNLP
          batchSizeRC
          datasetTestSizeThresholdNLP
          datasetTestSizeThresholdRC
          learningRateGN
          testSizeGN
          batchSizeGN
          datasetTestSizeThresholdGN
          enableManagedSpotTraining
          maxRuntimeWaitTime
          maxRuntime
          includeReadComprehensionDataInTraining
          generateDockerImageForRCengine
          generateDockerImageForNLPengine
          generateDockerImageForGNengine
          emailsListForTrainingConfirmation
          maxQueueWaitTime
        }
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createGenerationConfig = /* GraphQL */ `
  mutation CreateGenerationConfig(
    $input: CreateGenerationConfigInput!
    $condition: ModelGenerationConfigConditionInput
  ) {
    createGenerationConfig(input: $input, condition: $condition) {
      id
      styles
      domains
      scopes
      prompts {
        type
        label
        promptLength
        promptPlaceholder
        interpolationString
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateGenerationConfig = /* GraphQL */ `
  mutation UpdateGenerationConfig(
    $input: UpdateGenerationConfigInput!
    $condition: ModelGenerationConfigConditionInput
  ) {
    updateGenerationConfig(input: $input, condition: $condition) {
      id
      styles
      domains
      scopes
      prompts {
        type
        label
        promptLength
        promptPlaceholder
        interpolationString
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteGenerationConfig = /* GraphQL */ `
  mutation DeleteGenerationConfig(
    $input: DeleteGenerationConfigInput!
    $condition: ModelGenerationConfigConditionInput
  ) {
    deleteGenerationConfig(input: $input, condition: $condition) {
      id
      styles
      domains
      scopes
      prompts {
        type
        label
        promptLength
        promptPlaceholder
        interpolationString
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createArenaBattle = /* GraphQL */ `
  mutation CreateArenaBattle(
    $input: CreateArenaBattleInput!
    $condition: ModelArenaBattleConditionInput
  ) {
    createArenaBattle(input: $input, condition: $condition) {
      id
      firstAgent
      secondAgent
      firstAgentChatID
      secondAgentChatID
      winnerID
      createdAt
      creationTime
      updatedAt
      workspaceID
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateArenaBattle = /* GraphQL */ `
  mutation UpdateArenaBattle(
    $input: UpdateArenaBattleInput!
    $condition: ModelArenaBattleConditionInput
  ) {
    updateArenaBattle(input: $input, condition: $condition) {
      id
      firstAgent
      secondAgent
      firstAgentChatID
      secondAgentChatID
      winnerID
      createdAt
      creationTime
      updatedAt
      workspaceID
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteArenaBattle = /* GraphQL */ `
  mutation DeleteArenaBattle(
    $input: DeleteArenaBattleInput!
    $condition: ModelArenaBattleConditionInput
  ) {
    deleteArenaBattle(input: $input, condition: $condition) {
      id
      firstAgent
      secondAgent
      firstAgentChatID
      secondAgentChatID
      winnerID
      createdAt
      creationTime
      updatedAt
      workspaceID
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createBenchmark = /* GraphQL */ `
  mutation CreateBenchmark(
    $input: CreateBenchmarkInput!
    $condition: ModelBenchmarkConditionInput
  ) {
    createBenchmark(input: $input, condition: $condition) {
      id
      name
      description
      questions {
        type
        question
        answer
        reasoning
        context
        images
        files
      }
      workspaceID
      createdAt
      creationTime
      updatedAt
      metadata
      files
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateBenchmark = /* GraphQL */ `
  mutation UpdateBenchmark(
    $input: UpdateBenchmarkInput!
    $condition: ModelBenchmarkConditionInput
  ) {
    updateBenchmark(input: $input, condition: $condition) {
      id
      name
      description
      questions {
        type
        question
        answer
        reasoning
        context
        images
        files
      }
      workspaceID
      createdAt
      creationTime
      updatedAt
      metadata
      files
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteBenchmark = /* GraphQL */ `
  mutation DeleteBenchmark(
    $input: DeleteBenchmarkInput!
    $condition: ModelBenchmarkConditionInput
  ) {
    deleteBenchmark(input: $input, condition: $condition) {
      id
      name
      description
      questions {
        type
        question
        answer
        reasoning
        context
        images
        files
      }
      workspaceID
      createdAt
      creationTime
      updatedAt
      metadata
      files
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createProject = /* GraphQL */ `
  mutation CreateProject(
    $input: CreateProjectInput!
    $condition: ModelProjectConditionInput
  ) {
    createProject(input: $input, condition: $condition) {
      id
      name
      description
      startDate
      endDate
      status
      workspaceID
      agentID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateProject = /* GraphQL */ `
  mutation UpdateProject(
    $input: UpdateProjectInput!
    $condition: ModelProjectConditionInput
  ) {
    updateProject(input: $input, condition: $condition) {
      id
      name
      description
      startDate
      endDate
      status
      workspaceID
      agentID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteProject = /* GraphQL */ `
  mutation DeleteProject(
    $input: DeleteProjectInput!
    $condition: ModelProjectConditionInput
  ) {
    deleteProject(input: $input, condition: $condition) {
      id
      name
      description
      startDate
      endDate
      status
      workspaceID
      agentID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createReminder = /* GraphQL */ `
  mutation CreateReminder(
    $input: CreateReminderInput!
    $condition: ModelReminderConditionInput
  ) {
    createReminder(input: $input, condition: $condition) {
      id
      title
      description
      workspaceID
      projectID
      status
      priority
      dueDate
      completedDate
      recurringPattern
      assignedTo
      metadata
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateReminder = /* GraphQL */ `
  mutation UpdateReminder(
    $input: UpdateReminderInput!
    $condition: ModelReminderConditionInput
  ) {
    updateReminder(input: $input, condition: $condition) {
      id
      title
      description
      workspaceID
      projectID
      status
      priority
      dueDate
      completedDate
      recurringPattern
      assignedTo
      metadata
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteReminder = /* GraphQL */ `
  mutation DeleteReminder(
    $input: DeleteReminderInput!
    $condition: ModelReminderConditionInput
  ) {
    deleteReminder(input: $input, condition: $condition) {
      id
      title
      description
      workspaceID
      projectID
      status
      priority
      dueDate
      completedDate
      recurringPattern
      assignedTo
      metadata
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createProjectItem = /* GraphQL */ `
  mutation CreateProjectItem(
    $input: CreateProjectItemInput!
    $condition: ModelProjectItemConditionInput
  ) {
    createProjectItem(input: $input, condition: $condition) {
      id
      title
      description
      type
      status
      priority
      dueDate
      assignee
      metadata
      projectID
      workspaceID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateProjectItem = /* GraphQL */ `
  mutation UpdateProjectItem(
    $input: UpdateProjectItemInput!
    $condition: ModelProjectItemConditionInput
  ) {
    updateProjectItem(input: $input, condition: $condition) {
      id
      title
      description
      type
      status
      priority
      dueDate
      assignee
      metadata
      projectID
      workspaceID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteProjectItem = /* GraphQL */ `
  mutation DeleteProjectItem(
    $input: DeleteProjectItemInput!
    $condition: ModelProjectItemConditionInput
  ) {
    deleteProjectItem(input: $input, condition: $condition) {
      id
      title
      description
      type
      status
      priority
      dueDate
      assignee
      metadata
      projectID
      workspaceID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createCustomer = /* GraphQL */ `
  mutation CreateCustomer(
    $input: CreateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    createCustomer(input: $input, condition: $condition) {
      id
      name
      companyName
      email
      phone
      type
      status
      lifecycle
      segment
      pipeline
      lastContactDate
      nextFollowUpDate
      assignedTo
      totalRevenue
      potentialValue
      currency
      acquisitionSource
      relationshipStrength
      metadata
      notes
      createdAt
      updatedAt
      workspaceID
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateCustomer = /* GraphQL */ `
  mutation UpdateCustomer(
    $input: UpdateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    updateCustomer(input: $input, condition: $condition) {
      id
      name
      companyName
      email
      phone
      type
      status
      lifecycle
      segment
      pipeline
      lastContactDate
      nextFollowUpDate
      assignedTo
      totalRevenue
      potentialValue
      currency
      acquisitionSource
      relationshipStrength
      metadata
      notes
      createdAt
      updatedAt
      workspaceID
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteCustomer = /* GraphQL */ `
  mutation DeleteCustomer(
    $input: DeleteCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    deleteCustomer(input: $input, condition: $condition) {
      id
      name
      companyName
      email
      phone
      type
      status
      lifecycle
      segment
      pipeline
      lastContactDate
      nextFollowUpDate
      assignedTo
      totalRevenue
      potentialValue
      currency
      acquisitionSource
      relationshipStrength
      metadata
      notes
      createdAt
      updatedAt
      workspaceID
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createLog = /* GraphQL */ `
  mutation CreateLog(
    $input: CreateLogInput!
    $condition: ModelLogConditionInput
  ) {
    createLog(input: $input, condition: $condition) {
      id
      type
      action
      description
      metadata
      performedBy
      performedAt
      workspaceID
      projectItem
      customerItem
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateLog = /* GraphQL */ `
  mutation UpdateLog(
    $input: UpdateLogInput!
    $condition: ModelLogConditionInput
  ) {
    updateLog(input: $input, condition: $condition) {
      id
      type
      action
      description
      metadata
      performedBy
      performedAt
      workspaceID
      projectItem
      customerItem
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteLog = /* GraphQL */ `
  mutation DeleteLog(
    $input: DeleteLogInput!
    $condition: ModelLogConditionInput
  ) {
    deleteLog(input: $input, condition: $condition) {
      id
      type
      action
      description
      metadata
      performedBy
      performedAt
      workspaceID
      projectItem
      customerItem
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createEntitySnapshot = /* GraphQL */ `
  mutation CreateEntitySnapshot(
    $input: CreateEntitySnapshotInput!
    $condition: ModelEntitySnapshotConditionInput
  ) {
    createEntitySnapshot(input: $input, condition: $condition) {
      id
      workspaceID
      sortKey
      entityType
      entityID
      snapshotVersion
      snapshotData
      entityName
      ttl
      metadata
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateEntitySnapshot = /* GraphQL */ `
  mutation UpdateEntitySnapshot(
    $input: UpdateEntitySnapshotInput!
    $condition: ModelEntitySnapshotConditionInput
  ) {
    updateEntitySnapshot(input: $input, condition: $condition) {
      id
      workspaceID
      sortKey
      entityType
      entityID
      snapshotVersion
      snapshotData
      entityName
      ttl
      metadata
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteEntitySnapshot = /* GraphQL */ `
  mutation DeleteEntitySnapshot(
    $input: DeleteEntitySnapshotInput!
    $condition: ModelEntitySnapshotConditionInput
  ) {
    deleteEntitySnapshot(input: $input, condition: $condition) {
      id
      workspaceID
      sortKey
      entityType
      entityID
      snapshotVersion
      snapshotData
      entityName
      ttl
      metadata
      createdBy
      updatedBy
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
